const DICT4: { [prop: string]: string } = {
  阿党相为: 'ē dǎng xiāng wéi',
  阿尔及尔: 'ā ěr jí ěr',
  阿狗阿猫: 'ā gǒu ā māo',
  阿姑阿翁: 'ā gū ā wēng',
  阿基米德: 'ā jī mǐ dé',
  阿家阿翁: 'ā gū ā wēng',
  阿娇金屋: 'ā jiāo jīn wū',
  阿鲁巴岛: 'ā lǔ bā dǎo',
  阿猫阿狗: 'ā māo ā gǒu',
  阿毗地狱: 'ā pí dì yù',
  阿平绝倒: 'ā píng jué dǎo',
  阿其所好: 'ē qí suǒ hào',
  阿塞拜疆: 'ā sāi bài jiāng',
  唉声叹气: 'āi shēng tàn qì',
  挨风缉缝: 'āi fēng jī fèng',
  挨家挨户: 'āi ji āi hù',
  挨肩并足: 'āi jiān bìng zú',
  挨肩擦背: 'āi jiān cā bèi',
  挨肩擦膀: 'āi jiān cā bǎng',
  挨肩擦脸: 'āi jiān cā liǎn',
  挨肩搭背: 'āi jiān dā bèi',
  挨肩迭背: 'āi jiān dié bèi',
  挨肩叠背: 'āi jiān dié bèi',
  挨门挨户: 'āi mén āi hù',
  挨门逐户: 'āi mén zhú hù',
  挨三顶五: 'āi sān dǐng wǔ',
  挨山塞海: 'āi shān sè hǎi',
  捱风缉缝: 'āi fēng qī fèng',
  矮人观场: 'ǎi rén guān cháng',
  矮子观场: 'ǎi zǐ guān cháng',
  爱人好士: 'ài rén hào shì',
  爱生恶死: 'ài shēng wù sǐ',
  安步当车: 'ān bù dàng chē',
  安常处顺: 'ān cháng chǔ shùn',
  安老怀少: 'ān lǎo huái shào',
  安身为乐: 'ān shēn wéi lè',
  安时处顺: 'ān shí chǔ shùn',
  按捺不住: 'àn nà bù zhù',
  按行自抑: 'àn xíng zì yì',
  按辔徐行: 'àn pèi xú xíng',
  暗斗明争: 'àn dòu míng zhēng',
  暗箭中人: 'àn jiàn zhòng rén',
  昂昂自若: 'áng áng zì roò',
  敖不可长: 'ào bù kě zhǎng',
  熬更守夜: 'áo gēng shǒu yè',
  鳌鸣鳖应: 'áo míng biē yīng',
  傲不可长: 'ào bù kě zhǎng',
  傲霜斗雪: 'ào shuāng dòu xuě',
  八大山人: 'bā tài shān rén',
  八难三灾: 'bā nàn sān zāi',
  八旗子弟: 'bā qí zi dì',
  巴巴结结: 'bā bā jiē jiē',
  扒耳搔腮: 'pá ěr sāo sāi',
  拔本塞原: 'bá běn sè yuán',
  拔本塞源: 'bá běn sè yuán',
  拔锅卷席: 'bá guō juǎn xí',
  把玩无厌: 'bǎ wán wǔ yàn',
  罢黜百家: 'bā chù bǎi jiā',
  白不呲咧: 'bái bù cī liě',
  白藋同心: 'bái diào tóng xīn',
  白袷蓝衫: 'bái jiá lán shān',
  白旄黄钺: 'bái máo huáng yuè',
  白首相知: 'bái shǒu xiāng zhī',
  白首为郎: 'bái shǒu wéi láng',
  白首相庄: 'bái shǒu xiāng zhuāng',
  白衣卿相: 'bái yī qīng xiàng',
  百不当一: 'bǎi bù dāng yī',
  百川朝海: 'bǎi chuān cháo hǎi',
  百堕俱举: 'bǎi huī jù jǔ',
  百发百中: 'bǎi fā bǎi zhòng',
  百孔千创: 'bǎi kǒng qiān chuāng',
  百了千当: 'bǎi liǎo qiān dāng',
  百鸟朝凤: 'bǎi niǎo cháo fèng',
  百舍重茧: 'bǎi shè chóng jiǎn',
  百舍重趼: 'bǎi shè chóng jiǎn',
  百兽率舞: 'bǎi shòu shuài wǔ',
  百下百着: 'bǎi xià bǎi zháo',
  百中百发: 'bǎi zhòng bǎi fā',
  败德辱行: 'bài dé rǔ xíng',
  败国丧家: 'bài guó sàng jiā',
  败军之将: 'bài jūn zhī jiàng',
  拜将封侯: 'bài jiàng fēng hóu',
  班师回朝: 'bān shī huí cháo',
  板上钉钉: 'bǎn shàng dìng dīng',
  半半拉拉: 'bàn bàn lā lā',
  半筹莫展: 'bàn chóu mò chǎn',
  半间半界: 'bàn gān bàn gà',
  半间不界: 'bàn gān bù gà',
  半上落下: 'bàn shàng luò xià',
  半吐半露: 'bàn tǔ bàn lù',
  半吞半吐: 'bàn tūn bàn tǔ',
  帮闲钻懒: 'bāng xián zuān lǎn',
  膀大腰圆: 'bǎng dà yāo yuán',
  傍若无人: 'páng ruò wú rén',
  褒贬与夺: 'bǎo biǎn yǔ duó',
  抱残守阙: 'bào cán shǒu quē',
  抱法处势: 'bào fǎ chǔ shì',
  抱关执钥: 'bào guān zhí yuè',
  抱蔓摘瓜: 'bào wàn zhāi guā',
  暴虎冯河: 'bào hǔ píng hé',
  暴露文学: 'bào lòu wén xué',
  暴腮龙门: 'pù sāi lóng mén',
  暴衣露盖: 'pù yī lù gài',
  暴衣露冠: 'pù yī lù guàn',
  陂湖禀量: 'bēi hú bǐng liáng',
  卑宫菲食: 'bēi gōng fěi shí',
  悲悲切切: 'bēi bēi qiè qiē',
  悲声载道: 'bēi shēng zài dào',
  北鄙之声: 'bēi bǐ zhī shēng',
  北鄙之音: 'bēi bǐ zhī yīn',
  北辰星拱: 'bēi chén xīng gǒng',
  北窗高卧: 'bēi chuāng gāo wò',
  北门管钥: 'běi mén guǎn yuè',
  背曲腰躬: 'bèi qǔ yāo gōng',
  背曲腰弯: 'bèi qǔ yāo wān',
  背义负恩: 'bèi yù fù ēn',
  背义负信: 'bèi yù fù xìn',
  背义忘恩: 'bèi yù wàng ēn',
  倍道而行: 'bèi dào ér xíng',
  倍道兼行: 'bèi dào jiān xíng',
  被发文身: 'pī fà wén shēn',
  被发缨冠: 'pī fà yīng guàn',
  被发左衽: 'pī fà zuǒ rèn',
  被褐怀玉: 'pī hè huái yù',
  被褐怀珠: 'pī hè huái zhū',
  被甲持兵: 'pī jiǎ chí bīng',
  被甲据鞍: 'pī jiǎ jù ān',
  被甲枕戈: 'pī jiǎ zhěn gē',
  被甲执兵: 'pī jiǎ zhí bīng',
  被山带河: 'pī shān dài hé',
  本枝百世: 'běn zhī bǒi shì',
  逼良为娼: 'bī liáng wéi chāng',
  比量齐观: 'bǐ liàng qí guān',
  比物属事: 'bǐ wù zhǔ shì',
  彼倡此和: 'bǐ chàng cǐ hè',
  彼唱此和: 'bǐ chàng cǐ hè',
  秕言谬说: 'bǐ yán miù shuò',
  闭合思过: 'bì gé sī guò',
  闭合自责: 'bì gé zì zé',
  闭门合辙: 'bì kǒu hé shé',
  闭门塞窦: 'bì kǒu sè dòu',
  闭门塞户: 'bì kǒu sè hù',
  闭门扫迹: 'bì kǒu sǎo guǐ',
  闭门思愆: 'bì gé sī qiān',
  闭明塞聪: 'bì míng sè cōng',
  闭目塞耳: 'bì mù sè ěr',
  闭目塞听: 'bì mù sè tīng',
  敝盖不弃: 'bǐ gài bù qì',
  敝绨恶粟: 'bì tí è sù',
  敝帷不弃: 'bǐ wéi bù qì',
  蔽聪塞明: 'bì cōng sè míng',
  蔽明塞聪: 'bì míng sè cōng',
  避烦斗捷: 'bì fán dòu jié',
  避难就易: 'bì nán jiù yì',
  避难趋易: 'bì nán qiù yì',
  鞭辟向里: 'biān bì xiàng lǐ',
  鞭辟着里: 'biān bì zhuó lǐ',
  鞭擗进里: 'bīan pì jìn lǐ',
  鞭擗向里: 'biān bì xiàng lǐ',
  鞭约近里: 'biān yuē jīn lǐ',
  便宜从事: 'biàn yí cóng shì',
  便宜施行: 'biàn yí shī xíng',
  便宜行事: 'biàn yì xíng shì',
  变风改俗: 'biàn fēng yì sú',
  变幻不测: 'biàn huà bù cè',
  变危为安: 'biàn wēi wéi ān',
  变贪厉薄: 'biǎn tān lì bó',
  飙发电举: 'biāo fā diàn jù',
  表里为奸: 'biǎo lǐ wéi jiān',
  摽梅之年: 'biào mén zhī nián',
  别创一格: 'bié chuàng yí gé',
  别鹤离鸾: 'bié hè lí láun',
  别开一格: 'bié kāi yí gé',
  别类分门: 'bié lèi fān mén',
  别无长物: 'bié wú cháng wù',
  彬彬济济: 'bīn bīn jǐ jǐ',
  冰解的破: 'bīng jiě dì pò',
  冰山易倒: 'bīng shān yì dǎo',
  兵不由将: 'bīng bù yóu jiàng',
  兵不血刃: 'bīng bù xuè rèn',
  兵多将广: 'bīng duō jiàng guǎng',
  兵强将勇: 'bīng qiáng àng yǒng',
  兵微将寡: 'bīng wēi jiàng guǎ',
  兵未血刃: 'bīng wèi xuě rèn',
  兵无血刃: 'bīng wú xuè rèn',
  兵行诡道: 'bīng xíng guǐ dào',
  丙种射线: 'bǐng zhǒng shè xiàn',
  并为一谈: 'bìng wéi yī tán',
  并赃拿贼: 'bìng zhuō ná zéi',
  病入骨隨: 'bìng rù gǔ suǐ',
  拨乱为治: 'bō luàn wéi zhì',
  波骇云属: 'bō hài yún zhǔ',
  波属云委: 'bō zhǔ yún wěi',
  玻璃纤维: 'bō li xiān wéi',
  剥肤椎髓: 'bō fū chuí suǐ',
  剥皮抽筋: 'bō pí chōu jīn',
  播穅眯目: 'bō kāng mǐ mù',
  播糠眯目: 'bō kāng mǐ mù',
  伯乐一顾: 'bō lè yī gù',
  博文约礼: 'bó wén yuè lǐ',
  博闻强识: 'bó wén qiáng zhì',
  薄寒中人: 'bó hán zhòng rén',
  薄情无义: 'báo qíng wú yì',
  薄物细故: 'bó wù xì gù',
  簸土扬沙: 'bǒ tǔ yáng shā',
  擘两分星: 'bó liǎng fēn xīng',
  餔糟啜漓: 'bǔ zāo chuò lí',
  补阙灯檠: 'bǔ quē dēng qíng',
  补阙挂漏: 'bǔ quē guà lòu',
  补阙拾遗: 'bǔ quē shí yí',
  不拔一毛: 'bù bá yì máo',
  不辟斧钺: 'bù bì fǔ yuè',
  不差毫发: 'bù chā háo fà',
  不差毫厘: 'bù chā háo lí',
  不差累黍: 'bù chā lěi shǔ',
  不差上下: 'bù chā shàng xià',
  不差什么: 'bù chà shí mǒ',
  不偢不倸: 'bù chǒu bù cǎi',
  不当不正: 'bù dāng bù zhèng',
  不当人子: 'bù dāng rén zǐ',
  不登大雅: 'bù dēng dà yǎ',
  不分青白: 'bù fēn qīng béi',
  不干不净: 'bù gān bù jìng',
  不根之谈: 'bù gān zhī tán',
  不哼不哈: 'bù hēng bù hā',
  不护细行: 'bù hù xì xíng',
  不怀好意: 'bù huái hào yì',
  不遑宁处: 'bù huáng níng chǔ',
  不遑启处: 'bù huáng qǐ chǔ',
  不讳之朝: 'bù huì zhī cháo',
  不间不界: 'bù gān bù gà',
  不见经传: 'bù jiàn jīng zhuàn',
  不见天日: 'bù jiàn tiān rì',
  不矜不伐: 'bù jīn bù fá',
  不矜细行: 'bù jīn xì xíng',
  不紧不慢: 'bù jīn bù màn',
  不揪不睬: 'bù chǒu bù cǎi',
  不拘细行: 'bù jū xì xíng',
  不拘形迹: 'bù jū xíng jī',
  不绝如发: 'bù jué rú fà',
  不可揆度: 'bù kě kuí duó',
  不可奈何: 'bù kě mài hé',
  不可胜举: 'bù kě shèng jù',
  不可胜数: 'bù kě shèng shǔ',
  不愧不怍: 'bù kuì bù zuò',
  不了而了: 'bù liǎo ér liǎo',
  不了了之: 'bù liǎo liǎo zhī',
  不露锋铓: 'bù lù fēng huì',
  不奈之何: 'bù nai zhī hé',
  不破不立: 'bù può bù lì',
  不切实际: 'bù qiē shí jì',
  不省人事: 'bù xǐng rén shì',
  不失黍絫: 'bù shī shǔ lěi',
  不识起倒: 'bù shí qǐ dǎo',
  不随以止: 'bu shui yi zi',
  不贪为宝: 'bù tān wé bǎo',
  不吐不茹: 'bù tǔ bù rú',
  不为已甚: 'bù wéi yǐ shèn',
  不相为谋: 'bù xiāng wéi móu',
  不虚此行: 'bù xū cǐ xíng',
  不徇私情: 'bù xún sī qíng',
  不义之财: 'bù yì zhī cái',
  不亦善夫: 'bù yi shàn fū',
  不越雷池: 'bù yuè léi shi',
  不知薡蕫: 'bù zhī dīng dǒng',
  不知起倒: 'bù zhī qǐ dǎo',
  不着疼热: 'bù zhuó téng rè',
  不足齿数: 'bù zú chǐ shǔ',
  不足为法: 'bù zú wéi fǎ',
  不足为凭: 'bù zú wéi píng',
  不足为据: 'bù zú wéi jù',
  不足为奇: 'bù zú wéi qí',
  不足为训: 'bù zú wéi xùn',
  不足为意: 'bù zú wéi yì',
  布鲁塞尔: 'bù lǔ sài ěr',
  步步为营: 'bù bù wéi yíng',
  步线行针: 'bù xiàn xíng zhēn',
  擦拳抹掌: 'cā quán mò zhǎng',
  才薄智浅: 'cāi bó zhì qiǎn',
  才大难用: 'cái dà nán yòng',
  才高行洁: 'cái gāo xíng jié',
  才高行厚: 'cái gāo xíng hòu',
  才轻德薄: 'cái qīng dé bó',
  才疏德薄: 'cái shū dé bó',
  才占八斗: 'cái zhān bā dǒu',
  材薄质衰: 'cái bó zhì shuāi',
  材大难用: 'cái dà nán yòng',
  材茂行洁: 'cái mào xíng jié',
  材茂行絜: 'cái mào xíng jié',
  材轻德薄: 'cái qīng dé bó',
  材朽行秽: 'cái xiǔ xíng huì',
  材优干济: 'cái yōu gàn jǐ',
  财不露白: 'cái bù lù bái',
  财大气粗: 'cái dà qì cù',
  财殚力痡: 'cái dān lì pū',
  参辰日月: 'shēn chén rì yuè',
  参辰卯酉: 'shēn chén mǎo yǒu',
  参回斗转: 'shēn huí dǒu zhuǎn',
  参横斗转: 'shēn héng dǒu zhuǎn',
  参伍错综: 'cēn wǔ cuò zōng',
  骖风驷霞: 'cēn fēng sì xiá',
  餐风宿草: 'cān fēng sù xuě',
  餐风咽露: 'cān fēng yàn lù',
  餐松啖柏: 'cān sōng dàn biǎ',
  惨澹经营: 'cǎn dàn jīng yíng',
  惨绿愁红: 'cǎn lü chóu hóng',
  苍蝇见血: 'cāng yíng jiàn xuě',
  藏踪蹑迹: 'cáng zōng niè jī',
  操戈同室: 'cāo gē tóon shì',
  操奇逐赢: 'cāo qì zhù yíng',
  操身行世: 'cāo shēn xíng shì',
  草长莺飞: 'cǎo zhǎng yīng fēi',
  草率将事: 'cǎo lǜ jiāng shì',
  草行露宿: 'cǎo xíng lù sù',
  层见迭出: 'céng chū dié jiàn',
  层台累榭: 'céng tái lěi xiè',
  察察为明: 'chá chá wéi míng',
  察言观行: 'chá yán guān xíng',
  差强人意: 'chā qiáng rén yì',
  差三错四: 'chā sān cuò sì',
  禅世雕龙: 'chán shì diāo lóng',
  禅絮沾泥: 'chán xū zhān ní',
  缠夹不清: 'chán jiā bù qīng',
  刬草除根: 'chǎn cǎo chú gēn',
  刬恶锄奸: 'chǎn è chú jiān',
  刬旧谋新: 'chǎn jiù móu xīn',
  剗草除根: 'chǎn cǎo chú gēn',
  剗恶锄奸: 'chǎn è chú jiān',
  剗旧谋新: 'chǎn jiù móu xīn',
  谄上抑下: 'chǎn shàng yi xià',
  昌亭旅食: 'cháng tíng lǚ shí',
  长傲饰非: 'zhǎng ào shì fēi',
  长春不老: 'cháng chún bù lǎo',
  长恶靡悛: 'cháng è mǐ quān',
  长歌当哭: 'cháng gē dàng kū',
  长虺成蛇: 'zhǎng huǐ chéng shé',
  长鸣都尉: 'cháng míng dōu wèi',
  长年累月: 'cháng nián lěi yuè',
  长年三老: 'zhǎng nián sān lǎo',
  长篇累牍: 'cháng piān lěi dú',
  长生不死: 'cháng shēng bū sǐ',
  长绳系日: 'cháng shéng jì rì',
  长幼有序: 'zhǎng yòu yǒu xù',
  长幼有叙: 'zhǎng yòu yǒu xù',
  长幼尊卑: 'zhǎng yòu zūn bēi',
  苌弘碧血: 'cháng hóng bì xuě',
  畅所欲为: 'chàng suǒ yù wéi',
  倡而不和: 'chàng ér bù hè',
  倡条冶叶: 'chāng tiáo yě yè',
  超今冠古: 'chāo jīn guàn gǔ',
  巢居穴处: 'cháo jū xué chǔ',
  朝成暮徧: 'cháo chéng mù shí',
  朝攀暮折: 'zhāo pān mù shé',
  朝前夕惕: 'zhāo qiáng xī tì',
  朝乾夕愓: 'zhāo qián xī dàng',
  朝升暮合: 'zhāo shēng mù gě',
  朝阳丹凤: 'cháo yáng dān fèng',
  朝阳鸣凤: 'zhāo yáng míng fèng',
  朝章国典: 'cháo zhāng guó diǎn',
  朝章国故: 'cháo zhāng guó gù',
  朝折暮折: 'zhāo shé mù shé',
  朝种暮获: 'zhāo zhǒng mù hù',
  车尘马迹: 'chē zhén mǎ jì',
  车载船装: 'chē zǎi chuán zhuāng',
  扯顺风旗: 'chě shǔn fēng qí',
  扯纤拉烟: 'chě qiàn lā yān',
  嗔目切齿: 'chēn mù qiē chǐ',
  沉疴宿疾: 'chén kē sù jì',
  沉谋重虑: 'chén móu chóng lǜ',
  沉吟不决: 'chén yīn bù jué',
  沉吟章句: 'chén yīn zhāng jù',
  晨昏定省: 'chén hūn dìng xǐng',
  称德度功: 'chēng dé duó gōng',
  称家有无: 'chèn jiā yǒu wú',
  称体裁衣: 'chèn tǐ cái yī',
  称体载衣: 'chèn tǐ cái yī',
  称雨道晴: 'chēng yǔ dào aíng',
  趁风使柁: 'chèn fēng shǐ duò',
  趁哄打劫: 'chèn hōng dǎ jié',
  趁水和泥: 'chèn shuǐ huò ní',
  成败兴废: 'chéng bài xīng fèi',
  成吉思汗: 'chéng jí sī hán',
  成家立业: 'chéng jiā lì yiè',
  成年累月: 'chéng nián lěi yuè',
  成一家言: 'chěng yī jiān yán',
  城北徐公: 'chéng běi xǘ gōng',
  乘肥衣轻: 'chéng féi yì qīng',
  乘云行泥: 'chéng yún xíng ní',
  逞娇斗媚: 'chěng jiāo dòu mèi',
  逞妍斗色: 'chěng yán dòu sè',
  骋耆奔欲: 'chěng qí bēn yù',
  吃里扒外: 'chī lǐ pá wài',
  吃着不尽: 'chī zhuó bù jìn',
  迟迟吾行: 'chí chí wú xíng',
  持正不阿: 'chí zhèng bù ā',
  尺板斗食: 'chǐ bǎn dòu shí',
  尺寸之功: 'chǐ cù zhī gōng',
  尺短寸长: 'chǐ duǎn cù cháng',
  尺二冤家: 'chǐ èr yuān jia',
  齿豁头童: 'chǐ huō tóu tóng',
  齿牙为猾: 'chǐ yá wéi huá',
  齿牙为祸: 'chǐ yá wéi huò',
  耻与哙伍: 'chǐ yú kuài wǔ',
  赤绳系足: 'chì shéng jì zú',
  冲冠发怒: 'chōng guàn fā nù',
  冲冠怒发: 'chōng guàn nù fà',
  冲冠眦裂: 'chōng guàn zì liè',
  抽祕骋妍: 'chōu bì chěng yán',
  抽丝剥茧: 'chōu sī bāo jiǎn',
  愁红惨绿: 'chóu hóng cǎn lü',
  愁眉不展: 'chóu méi bù zhān',
  愁山闷海: 'chóu shān mèn hǎi',
  臭味相投: 'xiù wèi xiāng tóu',
  出处进退: 'chū chǔ jìn tuì',
  出处殊涂: 'chū chǔ shū tú',
  出处殊途: 'chū chǔ shū tú',
  出处语默: 'chū chǔ yǔ mò',
  出乖露丑: 'chū guāi lù chǒu',
  出将入相: 'chū jiàng rù xiàng',
  出门应辙: 'chū mén yīng zhé',
  出奇划策: 'chū qí huá cè',
  出入无间: 'chū rù wú jiān',
  出头露面: 'chū tóu lù miàn',
  出言吐词: 'chū yán tǔ cí',
  出言吐语: 'chū yán tǔ yǔ',
  樗栎庸材: 'chū lì yōng cái',
  处高临深: 'chǔ gāo lín shēn',
  处实效功: 'chǔ shí xiào gōng',
  处堂燕雀: 'chǔ táng yàn què',
  处堂燕鹊: 'chǔ táng yàn què',
  处心积虑: 'chǔ xīn jī lǜ',
  处之泰然: 'chǔ zhī tài rán',
  处尊居显: 'chǔ zūn jū xiǎn',
  触处机来: 'chù chǔ jī lái',
  触斗蛮争: 'chù dòu mán zhēng',
  揣骨听声: 'chuāi gǔ tīng shēng',
  揣奸把猾: 'chuāi jiān bǎ huá',
  揣时度力: 'chuǎi shí duó lì',
  啜食吐哺: 'chuò shí tǔ bǔ',
  啜英咀华: 'chuò yīng jǔ huá',
  川渟岳峙: 'chuān tīng yuè zhì',
  穿红着绿: 'chuān hóng zhuó lǜ',
  传风搧火: 'chuán fēng yǒu huǒ',
  传风扇火: 'chuán fēng shān huǒ',
  传神阿堵: 'chuán shén ā dǔ',
  传为佳话: 'chuán wéi jiā huà',
  传为美谈: 'chuán wéi měi tán',
  传为笑柄: 'chuán wéi xiào bǐng',
  传为笑谈: 'chuán wéi xiào tán',
  窗明几净: 'chuāng míng jī jìng',
  床下牛斗: 'chuáng xià niú dòu',
  创巨痛深: 'chuāng jù tòng shēn',
  吹竹弹丝: 'chuí zhú dàn sī',
  垂首帖耳: 'chuí shǒu tiē ěr',
  垂头搨翼: 'chuí tóu dá yì',
  春风风人: 'chūn fēng fèng rén',
  春风一度: 'chūn fēng yī dù',
  春笋怒发: 'chūn sǔn mù fā',
  纯属骗局: 'chún shú piàn jú',
  慈悲为本: 'cí bēi wéi běn',
  此唱彼和: 'cǐ chàng bǐ hè',
  此动彼应: 'cǐ dòng bǐ yīng',
  此发彼应: 'cǐ fā bǐ yīng',
  此呼彼应: 'cǐ hū bǐ yīng',
  从俗就简: 'cóng sú jiù jiǎ',
  摧刚为柔: 'cuī gāng wéi róu',
  摧折豪强: 'cuī zhé háo qiáng',
  榱崩栋折: 'cuī bēng dòng shé',
  榱栋崩折: 'cuī dòng bēng shé',
  啛啛喳喳: 'cuì cuì chā chā',
  村生泊长: 'cūn shēng bó cháng',
  寸步难行: 'cùn bù nán xíng',
  寸积铢累: 'cùn jī zhū lěi',
  寸利必得: 'cùn lì bì dé',
  撮科打哄: 'cuō kē dǎ hòng',
  撮土焚香: 'cuō gǔ fén xiāng',
  撮科打閧: 'cuō kē dǎ hòng',
  厝火燎原: 'cuò huǒ liǎo yuán',
  沓来麕至: 'tà lái yǒu zhì',
  沓来踵至: 'tǎ lái zhǒng zhì',
  打躬作揖: 'dǎ gōng zuō yī',
  打家截舍: 'dǎ jiā jié shě',
  打马虎眼: 'dǎ mǎ hu yǎn',
  打闷葫芦: 'dǎ mèn hú lu',
  大脖子病: 'dà bó zi bìng',
  大步流星: 'dǎ bù liú xīng',
  大车以载: 'dà chē yǐ zài',
  大吃大喝: 'dà chī dà hè',
  大处着墨: 'dà chù zhuó mò',
  大处着眼: 'dà chù zhuó yǎn',
  大吹大擂: 'dà chuī dà léi',
  大而无当: 'dà ér wú dàng',
  大腹便便: 'dà fù pián pián',
  大明法度: 'dà jíng fǎ dù',
  大缪不然: 'dà miù bù rán',
  大璞不完: 'tài bú bù wán',
  大人先生: 'dà rén xiān sheng',
  大喜若狂: 'dā xǐ ruò kuáng',
  大雅君子: 'dà yǎ jūn zǐ',
  大雅之堂: 'dà yǎ zhī táng',
  大有可为: 'dà yǒu kě wéi',
  大雨滂沱: 'dà yǔ páng tuó',
  代人说项: 'dài rén shuō xiàng',
  代为说项: 'dài wéi shuō xiàng',
  戴绿帽子: 'dài lǜ mào zi',
  戴日戴斗: 'dài rì dài dòu',
  丹凤朝阳: 'dān fèng cháo yáng',
  单枪匹马: 'dān qiāng pí mǎ',
  箪食壶浆: 'dān sì hú jiāng',
  箪食壶酒: 'dān sì hú jiǔ',
  箪食瓢饮: 'dān sì piáo yǐn',
  胆大心粗: 'dǎn dā xīn cū',
  诞谩不经: 'dàn màn bù jīng',
  弹铗无鱼: 'dàn jiá wú yú',
  弹尽粮绝: 'dàn jìn liáng jué',
  弹尽援绝: 'dàn jìn yuán jué',
  弹丸脱手: 'tán wán tuō shǒu',
  弹无虚发: 'dàn wú xū fā',
  弹雨枪林: 'dàn yǔ qiāng lín',
  淡泊明志: 'dàn bó míng zhì',
  淡然处之: 'dàn rán chǔ zhī',
  淡汝浓抹: 'dàn zhuāng nóng mǒ',
  淡妆轻抹: 'dàn zhuāng qīng mò',
  澹泊寡欲: 'dàn bó guǎ yù',
  当务始终: 'dang wu shi zhong',
  当行本色: 'dāng xíng běn sè',
  当着不着: 'dāng zhuó bù zhuó',
  当轴处中: 'dāng zhóu chǔ zhōng',
  党豺为虐: 'dǎng chái wéi nüè',
  刀耕火种: 'dāo gēng huǒ zhòng',
  刀光血影: 'dāo guāng xuè yǐng',
  叨陪末座: 'tāo péi mò zuò',
  叨在知己: 'tāo zài zhī jǐ',
  倒持干戈: 'dǎo chí gān gē',
  倒持手板: 'dǎo chí shǒu bǎn',
  倒持戈矛: 'dǎo chí gē máo',
  倒持太阿: 'dǎo chí tài ā',
  倒凤颠鸾: 'dǎo fèng diān luán',
  倒冠落佩: 'dǎo guān luò pèi',
  倒冠落珮: 'dǎo guàn luò pèi',
  倒果为因: 'dào guǒ wéi yīn',
  倒海翻江: 'dǎo hǎi fān jiāng',
  倒街卧巷: 'dǎo jiē wò xiàng',
  倒廪倾囷: 'dǎo lǐn qīng qūn',
  倒买倒卖: 'dǎo mǎi dǎo mài',
  倒戢干戈: 'dǎo jí gān gē',
  倒箧倾筐: 'dǎo qiè qīng kuāng',
  倒箧倾囊: 'dǎo qiè qīng náng',
  倒三颠四: 'dǎo sān diān sì',
  倒山倾海: 'dǎo shān qīng hǎi',
  倒裳索领: 'dào cháng suǒ lǐng',
  倒峡泻河: 'dǎo xiá xiè hé',
  倒行逆施: 'dào xíng nì shī',
  倒因为果: 'dǎo yīn wéi guǒ',
  倒载干戈: 'dào zài gān gē',
  倒执手版: 'dǎo zhí shǒu bǎn',
  捣虚撇抗: 'dǎo xū piē kàng',
  捣虚批吭: 'dǎo xū pī háng',
  蹈锋饮血: 'dǎo fēng yǐn xuè',
  蹈其覆辙: 'dǎo qì fù zhé',
  道德行为: 'dào dé xíng wéi',
  道远日暮: 'dào yuàn rì mù',
  得薄能鲜: 'dé bó néng xiān',
  得马折足: 'dé mǎ shé zú',
  得胜回朝: 'dé shèng huí cháo',
  得手应心: 'dé shǒu yīng xīn',
  得未曾有: 'dé wèi céng yǒu',
  德薄才疏: 'dé bó cái shū',
  德薄能鲜: 'dé bó néng xiǎn',
  德浅行薄: 'dé qiǎn xíng báo',
  的一确二: 'dí yī què èr',
  灯蛾扑火: 'dé é pū huǒ',
  灯尽油干: 'dēng jìn yóu gàn',
  登台拜将: 'dēng tái bài jiàng',
  登坛拜将: 'dēng tán bài jiàng',
  低唱浅斟: 'dì chàng qiǎn zhēn',
  低唱浅酌: 'dì chàng qiǎn zhuó',
  滴滴答答: 'dī dī dā dā',
  敌王所忾: 'dí wáng suǒ kài',
  底死谩生: 'dǐ sǐ màn shēng',
  砥节砺行: 'dǐ jié lì xíng',
  砥身砺行: 'dǐ shēn lì xíng',
  砥行立名: 'dǐ xíng lì míng',
  砥行磨名: 'dǐ xíng mó míng',
  地动山摇: 'dì dòng shēn yáo',
  帝王将相: 'dì wáng jiòn xiàng',
  掂斤抹两: 'diān jīn mò liǎng',
  颠倒干坤: 'diān dǎo gàn kūn',
  颠倒衣裳: 'diān dǎo yī cháng',
  颠颠倒倒: 'diān diān dǎo dǎo',
  颠来簸去: 'diān lái bǒ qù',
  颠来倒去: 'diān lái dǎo qù',
  颠鸾倒凤: 'diān luán dǎo fèng',
  颠乾倒坤: 'diān qiān dǎo kūn',
  颠三倒四: 'diān sān dǎo sì',
  点手划脚: 'diǎn shǒu jí jiǎo',
  点石为金: 'diǎn shí wéi jīn',
  点指划脚: 'diǎn zhǐ jí jiǎo',
  钿合金钗: 'diàn hé jīn chāi',
  刁钻促搯: 'diāo zuàn cù chāo',
  刁钻促狭: 'diāo zuàn cù xiá',
  雕虫薄技: 'diāo chóng báo jì',
  雕虫末伎: 'diāo chóng mò jì',
  雕蚶镂蛤: 'diāo hān lòu gé',
  雕心雁爪: 'diāo xīn yàn zhǎo',
  吊儿郎当: 'diào er láng dāng',
  吊尔郎当: 'diào er láng dāng',
  调兵遣将: 'diào bīng qiǎn jiàng',
  调虎离山: 'diào hǔ lí shān',
  调弦品竹: 'diào xián pǐn zhú',
  调嘴调舌: 'tiáo zuǐ diào shé',
  跌弹斑鸠: 'diē dàn bān jiū',
  跌宕不羁: 'dié dàng bù jī',
  迭矩重规: 'dié jǔ chóng guī',
  叠矩重规: 'dié jǔ chóng guī',
  钉头磷磷: 'ding tou lin lin',
  鼎铛玉石: 'dǐng chēng yù shí',
  鼎铛有耳: 'dǐng chēng yǒu ěr',
  鼎鼐调和: 'dǐng nai tiáo hé',
  鼎折覆餗: 'dǐng shé fù sù',
  鼎折餗覆: 'dǐng shé sù fù',
  丢魂丧胆: 'diu1 hún sàng dǎn',
  丢三落四: 'diū sān là sì',
  丢三拉四: 'diu sān lā sì',
  丢卒保车: 'diū zú bǎo jū',
  东挨西撞: 'dōng āi xī zhuàng',
  东猜西揣: 'dōng cāi xī chuāi',
  东扯西拽: 'dōng chě xī zhuāi',
  东床姣婿: 'dōng chuáng jiāo xù',
  东倒西歪: 'dōng dǎo xī wāi',
  东躲西藏: 'dōng duǒ xī cáng',
  东方将白: 'dong fang jiang bai',
  东扶西倒: 'dōng fú xī dǎo',
  东观西望: 'dōng guāng xī wàng',
  东横西倒: 'dōng héng xī dǎo',
  东家西舍: 'dōng jiā xī shě',
  东量西折: 'dōng liàng xī shé',
  东鳞西爪: 'dōng lín xī zhǎo',
  东鸣西应: 'dōng míng xī yīng',
  东抹西涂: 'dōng mò xī tú',
  东飘西泊: 'dōng piāo xī bó',
  东市朝衣: 'dōng shì cháo yī',
  东歪西倒: 'dōng wāi xī dǎo',
  东踅西倒: 'dōng xué xī dǎo',
  东支西吾: 'dōng zhī xī wú',
  动如参商: 'dòng rú cān shāng',
  动中窾要: 'dòng zhōng zhe yào',
  恫疑虚喝: 'dòng yí xū hè',
  恫疑虚猲: 'dòng yí xū gé',
  栋折榱坏: 'dòng shé cuī huài',
  洞见症结: 'dòng jiàn zhèng jié',
  都俞吁咈: 'dōu yú xū fú',
  兜肚连肠: 'dōu dǔ lián cháng',
  斗唇合舌: 'dòu chún hé shé',
  斗而铸兵: 'dòu ér zhù bīng',
  斗而铸锥: 'dòu ér zhù zhuī',
  斗怪争奇: 'dòu guài zhēng qí',
  斗酒双柑: 'dòu jiǔ shuāng gān',
  斗丽争妍: 'dòu lì zhēng yán',
  斗美夸丽: 'dòu měi kuā lì',
  斗媚争妍: 'dòu mèi zhēng yán',
  斗色争妍: 'dòu sè zhēng yán',
  斗筲穿窬: 'dòu shāo chuān yú',
  斗霜傲雪: 'dòu shuāng ào xuě',
  斗水活鳞: 'dòu shuǐ huó lín',
  斗心眼儿: 'dòu xīn yǎn ér',
  斗牙拌齿: 'dòu yá bàn chǐ',
  斗转参横: 'dǒu zhuǎn shēn héng',
  豆重榆瞑: 'dòu chóng yú míng',
  毒泷恶雾: 'dú lóng è wù',
  读书得间: 'dú shū dé jiàn',
  读书种子: 'dú shū zhǒng zǐ',
  独断专行: 'dú duàn zhuān xíng',
  独善吾身: 'dú shàn wú shēn',
  独有千秋: 'dú yòu qiān qiū',
  笃近举远: 'dǔ jìn jǔ juǎn',
  笃志好学: 'dǔ zhì hǎo xué',
  杜鹃啼血: 'dù juān tí xuě',
  杜默为诗: 'dù mò wéi shī',
  度德量力: 'duó dé liàng lì',
  度己以绳: 'duó jǐ yǐ shéng',
  蠹居棊处: 'dù jū què chǔ',
  蠹居棋处: 'dù jū qí chǔ',
  短褐不完: 'duān hè bù wán',
  短见薄识: 'duǎn jiàn bó shí',
  断长补短: 'duàn chāng bǔ duǎn',
  断长续短: 'duàn chāng xù duǎn',
  断发文身: 'duàn fà wén shēn',
  断还归宗: 'duàn huán guī zōng',
  断烂朝报: 'duàn làn cháo bào',
  堆案盈几: 'duī àn yíng jī',
  对薄公堂: 'duì bù gōng táng',
  顿开茅塞: 'dùn kāi máo sè',
  顿学累功: 'dùn xué lěi gōng',
  遁迹黄冠: 'dùn jì huáng guàn',
  遁世无闷: 'dùn shì wú mèn',
  遁俗无闷: 'dùn sú wú mèn',
  遁天妄行: 'dùn tiān wàng xíng',
  遁逸无闷: 'dùn yì wú mèn',
  多财善贾: 'duō cái shàn gǔ',
  多端寡要: 'duō duān guǎi yào',
  多口阿师: 'duō kǒu ā shī',
  多劳多得: 'duō láo duō de',
  多难兴邦: 'duō nàn xīng bāng',
  多钱善贾: 'duō qián shàn gǔ',
  多文为富: 'duō wén wéi fù',
  多言数穷: 'duō yán shuò qióng',
  多灾多难: 'duō zāi duō nàn',
  多种多样: 'duō zhǒng duō yàng',
  夺人所好: 'duó rén suǒ hào',
  朵颐大嚼: 'duǒ yī dà jiáo',
  屙金溺银: 'ē jīn niào yín',
  峨峨汤汤: 'é é shāng shāng',
  鹅行鸭步: 'é xíng yā bù',
  额手相庆: 'é shǒu xiāng qìng',
  扼襟控咽: 'è jīn kòng yān',
  扼吭夺食: 'è gāng duó shí',
  扼吭拊背: 'è gāng fǔ bèi',
  恶不去善: 'wù bù qù shàn',
  恶恶从短: 'wù wù cóng duǎn',
  恶居下流: 'wù jū xià liú',
  恶湿居下: 'wù shī jū xià',
  恶意中伤: 'è yì zhòng shāng',
  恶语中伤: 'è yǔ zhòng shāng',
  恶醉强酒: 'wù zuì qiǎng jiǔ',
  恶紫夺朱: 'wù zǐ duó zhū',
  饿殍载道: 'è piǎo zài dào',
  饿殍枕藉: 'è piǎo zhěn jí',
  遏恶扬善: 'è è yán shàn',
  恩不放债: 'ēn bù fàng zhai',
  儿女亲家: 'ér nǚ qìng jiā',
  儿女心肠: 'ér nǘ xīn cháng',
  耳目闭塞: 'ěr mù bì sāi',
  二十八宿: 'èr shí bā xiù',
  二竖为虐: 'èr shù wéi nüè',
  发短心长: 'fà duǎn xīn cháng',
  发奸擿伏: 'fā jiān tì fú',
  发蒙解缚: 'fā méng jiě fu',
  发蒙解惑: 'fā méng jiě huò',
  发蒙振落: 'fā méng zhèn luò',
  发蒙振聩: 'fā méng zhèn kuì',
  发怒冲冠: 'fā nù chōng guàn',
  发怒穿冠: 'fà nù chuān guān',
  发上冲冠: 'fā shàng chōng guàn',
  发上指冠: 'fā shàng zhǐ guàn',
  发秃齿豁: 'fà tū chǐ huò',
  发屋求狸: 'fā wū qiú lí',
  发隐擿伏: 'fā yǐn tī fú',
  发引千钧: 'fà yǐn qiān jūn',
  发踊冲冠: 'fà yǒng chōng guān',
  发植穿冠: 'fà zhí chuān guān',
  伐功矜能: 'fá gōng jīn néng',
  罚不责众: 'fá bù zé zhòng',
  罚不当罪: 'fá bù dāng zuì',
  法轮常转: 'fǎ lún cháng zhuàn',
  番窠倒臼: 'fān kē dǎo jiù',
  翻肠倒肚: 'fān cháng dǎo dǔ',
  翻黄倒皁: 'fān huáng dǎo yí',
  翻黄倒皂: 'fān huáng dǎo zào',
  翻江倒海: 'fān jiāng dǎo hǎi',
  翻箱倒柜: 'fān xiāng dǎo guì',
  翻箱倒笼: 'fān xiāng dǎo lóng',
  反败为胜: 'fǎn bài wéi shèng',
  反经行权: 'fǎn jīng xíng quán',
  反劳为逸: 'fǎn láo wéi yì',
  反老还童: 'fǎn lǎo huán tóng',
  反朴还淳: 'fǎn pǔ huán chún',
  反正还淳: 'fǎn zhèng huán chún',
  返本朝元: 'fǎn běn cháo yuán',
  返本还元: 'fǎn běn huán yuán',
  返本还源: 'fǎn běn huán yuán',
  返老还童: 'fǎn lǎo huán tóng',
  返朴还淳: 'fǎn pǔ huán chún',
  返朴还真: 'fǎn pǔ huán zhēn',
  犯而不校: 'fàn ér bù jiào',
  泛应曲当: 'fàn yīng qǔ dāng',
  贩夫皁隶: 'fàn fū yě lì',
  贩夫走卒: 'fàn fū zǒu fú',
  方寸万重: 'fāng cùn wàn chóng',
  方领圆冠: 'fāng lǐng yuán guàn',
  方枘圜凿: 'fāng ruì huán záo',
  方兴未艾: 'fāng xīng wèi ài',
  方言矩行: 'fāng yán jǔ xíng',
  防心摄行: 'fáng xīn shè xíng',
  放辟邪侈: 'fàng pì xié chǐ',
  飞鸿雪爪: 'fēi hóng xuě zhǎo',
  飞将数奇: 'fē jiàng shù jī',
  飞沙走砾: 'fēi shē zǒu lì',
  菲食薄衣: 'fěi shí bó yī',
  匪朝伊夕: 'fěi cháo yī xī',
  匪伊朝夕: 'fěi yí zhāo xī',
  沸沸汤汤: 'fèi fèi shāng shāng',
  分风劈流: 'fēn fēng pǐ liú',
  分毫不差: 'fēn háo bù chā',
  粪土不如: 'fèn tú bù rú',
  丰亨豫大: 'fēng hēng yù dà',
  丰屋蔀家: 'fēng wū zhī jiā',
  风掣雷行: 'fēng chè léi xíng',
  风尘肮脏: 'fēng chén āng zāng',
  风驰草靡: 'fēng chí cǎo mǐ',
  风驰电卷: 'fēng chí diàn juǎn',
  风驰云卷: 'fēng chí yún juǎn',
  风卷残云: 'fēng juǎn cán yún',
  风清月皎: 'fēng qīng yuè jiāo',
  风土人情: 'fēng tú rén qíng',
  风行一时: 'fēng xíng yī shī',
  风影敷衍: 'fēng yǐng fū yān',
  风云变幻: 'fēng yún bià huàn',
  风姿绰约: 'fēng zī chuō yué',
  封豨修蛇: 'fēng xī yǒu shé',
  蜂扇蚁聚: 'fēng shān yǐ jù',
  蜂腰削背: 'fēng yāo xuē bèi',
  蜂攒蚁集: 'fēng cuán yǐ jí',
  蜂攒蚁聚: 'fēng cuán yǐ jù',
  冯驩弹铗: 'féng huān dàn jiá',
  冯生弹铗: 'féng shēng dàn jiá',
  逢场作乐: 'féng chǎng zuò lè',
  逢人说项: 'féng rén shuō xiàng',
  凤泊鸾漂: 'fèng bó luán piāo',
  凤泊鸾飘: 'fèng bó luán piāo',
  凤靡鸾吪: 'fèng mǐ luán é',
  凤鸣朝阳: 'fèng míng zhāo yáng',
  奉为至宝: 'fèng wéi zhì bǎo',
  奉为圭臬: 'fèng wéi guī niè',
  奉为楷模: 'fèng wéi kǎi mó',
  佛头着粪: 'fó tóu zhuó fèn',
  佛头著粪: 'fó tóu zhuó fèn',
  否极泰回: 'pǐ jí tài huí',
  否极泰来: 'pǐ jí tài lái',
  否极阳回: 'pǐ jí yáng huí',
  否去泰来: 'pǐ qù tài lái',
  否往泰来: 'pǐ wǎng tài lái',
  否终复泰: 'pǐ zhōng fù tài',
  否终则泰: 'pǐ zhōng zé tài',
  肤见謭识: 'fū jiàn guǎng shí',
  肤皮潦草: 'fū pǐ liǎo cǎo',
  肤受之愬: 'fū shòu zhī xiāng',
  伏虎降龙: 'fú hǔ xiáng lóng',
  服服帖帖: 'fú fu tiē tiē',
  浮收勒折: 'fú shōu lè shé',
  符号逻辑: 'fú hào luó ji',
  福为祸始: 'fú wéi huò shǐ',
  福为祸先: 'fú wéi huò xiān',
  拊背搤吭: 'fǔ bèi hè kēng',
  俯首帖耳: 'fǔ shǒu tiē ěr',
  辅世长民: 'fǔ shì zhǎng mín',
  父为子隐: 'fù wéi zǐ yǐn',
  父债子还: 'fù zhài zǐ huán',
  负材矜地: 'fù cái jīn dì',
  负地矜才: 'fù dì jīn cái',
  负债累累: 'fù zhai lèi lèi',
  富国彊兵: 'fù guó jiāng bīng',
  富商巨贾: 'fù shāng jù jiǎ',
  腹载五车: 'fù zài wǔ chē',
  伽马射线: 'gā mǎ shè xiàn',
  改朝换代: 'gǎi cháo huàn dài',
  改朝换姓: 'gǎi cháo huàn xìng',
  改恶为善: 'gǎi è wéi shàn',
  改而更张: 'gǎi ér gèng zhāng',
  改曲易调: 'gǎi qǔ yì diào',
  改弦易调: 'gǎi xián yì diào',
  改行从善: 'gǎi xíng cóng shàn',
  改行迁善: 'gǎi xíng qiān shàn',
  改行为善: 'gǎi xíng wéi shàn',
  改行自新: 'gǎi xíng zì xīn',
  改玉改行: 'gǎi yù gǎi xíng',
  改张易调: 'gǎi zhāng yì diào',
  干城之将: 'gān chéng zhī jiàng',
  干脆利索: 'gàn cuì lì suǒ',
  干端坤倪: 'gàn duān kūn ní',
  干父之蛊: 'gàn fù zhī gǔ',
  干干净净: 'gàn gān jìng jìng',
  干戈载戢: 'gàn gē zǎi jí',
  干将莫邪: 'gān jiàng mò yé',
  干净利索: 'gàn jìng lì suǒ',
  干名犯义: 'gàn míng fàn yì',
  干啼湿哭: 'gàn tí shī kū',
  干霄蔽日: 'gàn xiāo bì rì',
  甘处下流: 'gān chǔ xià liú',
  甘分随时: 'gān fèn suí shí',
  甘贫守分: 'gān pín shǒu fēn',
  竿头日上: 'gān tóu rí shàng',
  敢为敢做: 'gǎn wéi gǎn zuò',
  敢作敢为: 'gǎn zuò gǎn wéi',
  旰食宵衣: 'gàn shí xiāo yī',
  旰食之劳: 'gàn shí zhī láo',
  岗头泽底: 'gāng tóu zé dǐ',
  钢化玻璃: 'gāng huà bō li',
  钢筋铁骨: 'gāng jīng tiě gǔ',
  高遏行云: 'gāo è xíng yún',
  高风劲节: 'gāo fēng jìng jié',
  高义薄云: 'gāo yì bó yún',
  膏场绣浍: 'gāo cháng xiù kuài',
  膏车秣马: 'gào chē mò mǎ',
  膏唇贩舌: 'gào chún fàn shé',
  膏唇岐舌: 'gào chún qí shé',
  膏泽脂香: 'gāo zé zhī xiāng',
  槁项没齿: 'gǎo xiàng méi chǐ',
  告老还家: 'gào lǎo huán jiā',
  告朔饩羊: 'gù shuò xì yáng',
  疙疙瘩瘩: 'gē gē dā dá',
  歌莺舞燕: 'gē yíng wǔ yàn',
  革心易行: 'gé xīn yì xíng',
  格格不吐: 'gē gē bù tǔ',
  格格不纳: 'gē gē bù nà',
  各奔前程: 'gè bèn qián chéng',
  各色名样: 'gè sè gè yàng',
  各行其是: 'gè xíng qí shì',
  各行其志: 'gè xíng qí zhì',
  各有所长: 'gè yǒu suǒ chéng',
  各有所好: 'gè yǒu suǒ hào',
  各自为战: 'gè zì wéi zhàn',
  根孤伎薄: 'gēn gū jì báo',
  根生土长: 'gēn shēn tǔ zhǎng',
  亘古奇闻: 'gèn gǔ qī wén',
  更长梦短: 'gēng cháng mèng duǎn',
  更唱迭和: 'gēng chàng dié hé',
  更唱叠和: 'gēng chàng dié hé',
  更待干罢: 'gèng dài gàn bà',
  更阑人静: 'gēng lán rén jǐng',
  更令明号: 'gēng lìng míng hào',
  更名改姓: 'gèng míng gǎi xìng',
  更难仆数: 'gēng nán pú shù',
  更仆难数: 'gēng pú nán shǔ',
  更仆难终: 'gēng pú nán zhōng',
  更弦改辙: 'gēng xián gǎi zhé',
  更弦易辙: 'gēng xián yì zhé',
  更姓改物: 'gēng xìng gǎi wù',
  羹藜唅糗: 'gēng lí hán qiǔ',
  弓调马服: 'gōng diào mǎ fú',
  功薄蝉翼: 'gōng bó chán yì',
  功成行满: 'gōng chéng xíng mǎn',
  攻城掠地: 'gōng chéng lüě dì',
  供不应求: 'gōng bù yìng qiú',
  供过于求: 'gōng guò yú qiú',
  恭行天罚: 'gōng xíng tiān fá',
  龚行天罚: 'gōng xíng tiān fá',
  拱肩缩背: 'gǒng jān suō bèi',
  拱手而降: 'gǒng shòu ér xiáng',
  共为唇齿: 'gòng wéi chún chǐ',
  共枝别干: 'gòng zhī bié gàn',
  勾心斗角: 'gōu xīn dòu jiǎo',
  钩心斗角: 'gōu xīn dòu jiǎo',
  钩爪锯牙: 'gōu zhǎo jù yá',
  狗心狗行: 'gǒu xīn gǒu xíng',
  狗行狼心: 'gǒu xíng láng xīn',
  狗续侯冠: 'gǒu xù hòu guàn',
  狗血淋头: 'gǒu xuè lín tóu',
  狗血喷头: 'gǒu xuè pēn tóu',
  苟合取容: 'gǒu hé qǔ ān',
  姑射神人: 'gū yè shén rén',
  孤独矜寡: 'gū dú guān guǎ',
  孤履危行: 'gū lǚ wēi xíng',
  沽名干誉: 'gū míng gàn yù',
  古调不弹: 'gǔ diào bù tán',
  古调单弹: 'gǔ diào dān tán',
  古为今用: 'gǔ wéi jīn yòng',
  骨头架子: 'gú tou jià zi',
  鼓唇咋舌: 'gǔ chún zǎ shé',
  鼓鼓囊囊: 'gǔ gǔ nāng nāng',
  鼓吻奋爪: 'gǔ wěn fèn zhǎo',
  故伎重演: 'gù jì zhòng yǎn',
  故态复还: 'gù tài fù huán',
  顾景惭形: 'gù yǐng cán xíng',
  顾曲周郎: 'gù qǔ zhōu láng',
  瓜葛相连: 'guā gě xiāng lián',
  寡见鲜闻: 'guǎ jiàn xiǎn wén',
  寡廉鲜耻: 'guǎ lián xiǎn chǐ',
  挂席为门: 'guà xí wéi mén',
  拐弯抹角: 'guǎi wān mò jiǎo',
  关情脉脉: 'guān qíng mài mài',
  观者如垛: 'guān zhě rú duǒ',
  官官相为: 'guān guān xiāng wéi',
  官运亨通: 'guān yùn hēng gōng',
  官止神行: 'guān zhǐ shén xíng',
  冠屦倒施: 'guàn jù dǎo shī',
  冠绝一时: 'guàn jué yī shí',
  冠山戴粒: 'guàn shān dài lì',
  贯斗双龙: 'guàn dòu shuāng lóng',
  广陵散绝: 'guǎng líng sǎn jué',
  广譬曲谕: 'guǎng pì qǔ yù',
  广文先生: 'guǎng wén xiān sheng',
  广种薄收: 'guǎng zhòng bó shōu',
  规行矩步: 'guī xíng jǔ bù',
  规行矩止: 'guī xíng jǔ zhǐ',
  规旋矩折: 'guī xuán jǔ shé',
  规重矩叠: 'guī chóng jǔ dié',
  瑰意奇行: 'guī yì qí xíng',
  瑰意琦行: 'guī yì qí xíng',
  鬼怕恶人: 'guǐ pà èr én',
  鬼使神差: 'guǐ shǐ shén chāi',
  桂折兰摧: 'guì shé lán cuī',
  桂折一枝: 'guì shé yī zhī',
  果行育德: 'guǒ xíng yù dé',
  裹血力战: 'guǒ xuè lì zhàn',
  过关斩将: 'guò guān zhǎn jiàng',
  过为已甚: 'guò wéi yǐ shèn',
  过隙白驹: 'guò xī bái jū',
  含宫咀征: 'hán gōng jǔ zhēng',
  含宫咀徵: 'hán gōng jǔ zhēng',
  含垢藏疾: 'hán gǒu cáng jí',
  含含糊糊: 'hán hán hu hū',
  含糊不明: 'hán hú bù míng',
  含糊其词: 'hán hú qí cí',
  含糊其辞: 'hán hú qí cí',
  含菁咀华: 'hán jīng jǔ huá',
  含蓼问疾: 'hán liǎo wèn jí',
  含商咀徵: 'hán shāng jǔ zhēng',
  含商咀征: 'hán shāng jǔ zhēng',
  含英咀华: 'hán yīng jǔ huá',
  邯郸重步: 'hán dān zhóng bù',
  寒酸落魄: 'hán suān luò pò',
  汗流夹背: 'hàn liú jiā bèi',
  汗血盐车: 'hàn xuè yán chē',
  熯天炽地: 'hàn tiān chì dì',
  毫发不爽: 'háo fà bù shuǎng',
  豪干暴取: 'háo gàn bào qǔ',
  豪横跋扈: 'háo héng bá hù',
  豪商巨贾: 'háo shāng jù jiǎ',
  好吃懒做: 'hào chī lǎn zuò',
  好大喜功: 'hào dà xǐ gōng',
  好丹非素: 'hào dān fēi sù',
  好恶不同: 'hǎo è bù tóng',
  好高骛远: 'hào gāo wù yuǎn',
  好酒贪杯: 'hào jiǔ tān bēi',
  好谋善断: 'hào móu shàn duàn',
  好奇尚异: 'hǎo qí shàng yì',
  好骑者堕: 'hào qí zhě duò',
  好善恶恶: 'hǎo shàn wù è',
  好善乐施: 'hào shàn lè shī',
  好生之德: 'hào shēng zhī dé',
  好事之徒: 'hào shì zhī tú',
  好为人师: 'hào wéi rén shī',
  好问决疑: 'hào wèn jué yí',
  好为事端: 'hào wéi shì duān',
  好问则裕: 'hào wèn zé yù',
  好行小惠: 'hào xíng xiǎo huì',
  好行小慧: 'hǎo xíng xiǎo huì',
  好佚恶劳: 'hǎo yì wù láo',
  好逸恶劳: 'hào yì wù láo',
  好勇斗狠: 'hào yǒng dòu hěn',
  好整以暇: 'hào zhěng yǐ xiá',
  好自为之: 'hào zì wéi zhī',
  号寒啼饥: 'háo hán tí jī',
  号咷大哭: 'háo táo dà kū',
  浩浩汤汤: 'hào hào shāng shāng',
  合从连衡: 'hé zòng lián héng',
  合而为一: 'hé ér wéi yī',
  合二为一: 'hé èr wéi yī',
  合两为一: 'hé liǎng wéi yī',
  合浦还珠: 'hé pǔ huán zhū',
  合浦珠还: 'hé pǔ zhū huán',
  何乐不为: 'hé lè bù wéi',
  何所不为: 'hé suǒ bù wéi',
  何足为奇: 'hé zú wéi qí',
  和颜说色: 'hé yán yuè sè',
  河北梆子: 'hé běi bāng zi',
  河涸海干: 'hé hé hǎi qián',
  河溓海晏: 'hé lián hǎi yàn',
  河溓海夷: 'hé lián hǎi yí',
  河南梆子: 'hé nán bāng zi',
  荷枪实弹: 'hè qiāng shí dàn',
  涸思干虑: 'hé sī qián lǜ',
  鹤处鸡群: 'hè chǔ jī qún',
  鹤发鸡皮: 'hè fà jī pí',
  鹤发松姿: 'hè fà sōng zī',
  鹤发童颜: 'hè fà tóng yán',
  鹤鸣九皋: 'hè míng jiǔ gāo',
  鹤行鸡群: 'hè xíng jī qún',
  黑更半夜: 'hēi gēng bàn yè',
  恨海难填: 'hèn hǎi nán tián',
  亨嘉之会: 'hēng jiā zhī huì',
  哼哈二将: 'hēng hā èr jiàng',
  横倒竖卧: 'héng dǎo shù wò',
  横恩滥赏: 'hèng ēn làn shǎng',
  横科暴敛: 'hèng kē bào liǎn',
  横抢武夺: 'hèng qiǎng wǔ duó',
  横抢硬夺: 'hèng qiǎng yìng duó',
  横拖倒拽: 'héng tuō dào zhuāi',
  横无忌惮: 'hèng wú jì dàn',
  横殃飞祸: 'hèng yāng fēi huò',
  横灾飞祸: 'hèng zāi fēi huò',
  横征暴赋: 'hèng zhēng bào fù',
  横征苛敛: 'hèng zhēng kē liǎn',
  横征苛役: 'hèng zhēng kē yì',
  衡石量书: 'héng shí liàng shū',
  红不棱登: 'hóng bù lēng dēng',
  红得发紫: 'hóng de fā zǐ',
  红绳系足: 'hóng shéng jì zú',
  洪都拉斯: 'hóng dōu lā sī',
  洪炉燎发: 'hóng lú liáo fà',
  鸿都买第: 'hóng dōu mǎi dì',
  鸿飞雪爪: 'hóng fēi xuě zhǎo',
  鸿渐于干: 'hóng jiàn yú gàn',
  鸿泥雪爪: 'hóng ní xuě zhǎo',
  厚此薄彼: 'hòu cǐ bó bǐ',
  厚德载物: 'hòu dé zài wù',
  厚古薄今: 'hòu gǔ bó jīn',
  厚积薄发: 'hòu jī bó fā',
  厚今薄古: 'hòu jīn bó gǔ',
  厚味腊毒: 'hòu wèi xī dú',
  呼不给吸: 'hū bù jǐ xī',
  呼来喝去: 'hū lái hè qù',
  呼卢喝雉: 'hū lú hè zhì',
  呼天抢地: 'hū tiān qiāng dì',
  呼天吁地: 'hū tiān yù dì',
  呼幺喝六: 'hū yāo hè liù',
  狐狸尾巴: 'hú li wěi ba',
  狐裘尨茸: 'hú qiú méng róng',
  胡思乱量: 'hú sī luàn liàng',
  胡行乱为: 'hú xíng luàn wéi',
  胡子拉碴: 'hú zǐ lā chā',
  胡作非为: 'hú zuò fēi wéi',
  胡作胡为: 'hú zuò hú wéi',
  胡作乱为: 'hú zuò luàn wéi',
  虎步龙行: 'hǔ bù lóng xíng',
  虎斗龙争: 'hǔ dòu lóng zhēng',
  互为表里: 'hù wéi biǎo lǐ',
  互为因果: 'hù wéi yīn guò',
  户限为穿: 'hù xiàn wéi chuān',
  花不棱登: 'huā bù lēng dēng',
  花簇锦攒: 'huā cù jǐn cuán',
  花攒锦簇: 'huā cuán jǐn cù',
  花攒锦聚: 'huā cuán jǐn jù',
  华亭鹤唳: 'huà tíng hè lì',
  化鸱为凤: 'huà chī wéi fèng',
  化腐为奇: 'huà fǔ wéi qí',
  化零为整: 'huà líng wéi zhěng',
  化为泡影: 'huà wéi pāo yǐng',
  化为乌有: 'huà wéi wū yǒu',
  化险为夷: 'huà xiǎn wéi yí',
  化枭为鸠: 'huà xiāo wéi jiū',
  化整为零: 'huà zhěng wéi líng',
  划地为牢: 'huá dì wéi láo',
  画荻和丸: 'huà dí huò wán',
  画地为牢: 'huà dì wéi láo',
  画地为狱: 'huà dì wéi yù',
  画蛇著足: 'huà shé zhuó zú',
  怀才不遇: 'huái cái bū yù',
  淮橘为枳: 'huái jú wéi zhǐ',
  槐南一梦: 'huái nán yī mēng',
  坏裳为裤: 'huài shang wéi kù',
  欢呼雀跃: 'huān hū qué yué',
  还淳反古: 'huán chún fǎn gǔ',
  还淳反朴: 'huán chún fǎn pǔ',
  还淳反素: 'huán chún fǎn sù',
  还淳返朴: 'huán chún fǎn pǔ',
  还醇返朴: 'huán chún fǎn pǔ',
  还年卻老: 'huán nián què lǎo',
  还年却老: 'huán nián què lǎo',
  还年驻色: 'huán nián zhù sè',
  还朴反古: 'huán pǔ fǎn gǔ',
  还我河山: 'huán wǒ hé shān',
  还元返本: 'huán yuán fǎn běn',
  还珠返璧: 'huán zhū fǎn bì',
  还珠合浦: 'huán zhū hé pǔ',
  还珠买椟: 'huán zhū mǎi dú',
  患难夫妻: 'huàn nàn fū qī',
  患难与共: 'huàn nàn yǔ gòng',
  患难之交: 'huàn nàn zhī jiāo',
  黄发垂髫: 'huáng fà chuí tiáo',
  黄发儿齿: 'huáng fà ér chǐ',
  黄发骀背: 'huáng fā dài bèi',
  黄冠草服: 'huáng guàn cǎo fú',
  黄冠草履: 'huáng guàn cǎo lǚ',
  黄冠野服: 'huáng guàn yě fú',
  潢池盗弄: 'huáng shi dào nòng',
  挥沐吐餐: 'huī mù tǔ cān',
  回船转舵: 'huí chuán zhǎn duò',
  回山倒海: 'huí shān dǎo hǎi',
  回天倒日: 'huí tiān dǎo rì',
  悔不当初: 'huǐ bù dāng chū',
  悔过自责: 'huǐ guò zì zè',
  诲人不惓: 'huì rén bù tiě',
  贿货公行: 'huì huò gōng xíng',
  贿赂公行: 'huì lù gōng xíng',
  晦盲否塞: 'huì máng pǐ sè',
  秽德垢行: 'huì dé gòu xíng',
  毁冠裂裳: 'huǐ guān liè cháng',
  毁家纾难: 'huǐ jiā shū nàn',
  毁钟为铎: 'huǐ zhōng wéi duó',
  毁舟为杕: 'huǐ zhōu wéi duò',
  昏定晨省: 'hūn dìng chén xǐng',
  昏镜重明: 'hūn jìng chóng míng',
  昏镜重磨: 'hūn jìng chóng mó',
  昏迷不省: 'hūn mí bù xǐng',
  浑抡吞枣: 'hún lún tūn zǎo',
  魂不著体: 'hún bù zhuó tǐ',
  魂颠梦倒: 'hún diān mèng dǎo',
  魂不着体: 'hún bù zhuó tǐ',
  魂飞魄丧: 'hún fēi pò sāng',
  混混噩噩: 'hún hún è è',
  混然一体: 'hún rán yī tǐ',
  混为一谈: 'hùn wéi yī tán',
  混应滥应: 'hùn yīng làn yīng',
  活剥生吞: 'huó bāo shēng tūn',
  火耕流种: 'huǒ gēng liú zhǒng',
  火急火燎: 'huǒ jí huǒ liǎo',
  火烧火燎: 'huǒ shāo huǒ liǎo',
  货而不售: 'huo er bu shou',
  货贿公行: 'huò huì gōng xíng',
  货赂大行: 'huò lù dà xíng',
  货赂公行: 'huò lù gōng xíng',
  获隽公车: 'huò jūn gōng chē',
  祸不单行: 'huò bù dān xíng',
  祸福相生: 'huò fú xiāng shēng',
  祸福相依: 'huò fú xiāng yī',
  祸福相倚: 'huò fú xiāng yī',
  祸为福先: 'huò wéi fú xiān',
  击排冒没: 'jī pái mào mò',
  叽里呱啦: 'jī lǐ guā lā',
  叽哩咕噜: 'jī lǐ gū lū',
  饥冻交切: 'jī dòng jiāo qiē',
  饥寒交切: 'jī hán jiāo qiē',
  鸡皮鹤发: 'jī pí hè fà',
  鸡声鹅斗: 'jī shēng é dòu',
  鸡争鹅斗: 'jī zhēng é dòu',
  积谗糜骨: 'jī chán méi gǔ',
  积德累功: 'jī dé lěi gōng',
  积德累善: 'jī dé lěi shàn',
  积德累仁: 'jī dé lěi rén',
  积露为波: 'jī lù wéi bō',
  积年累岁: 'jī nián lěi suì',
  积年累月: 'jī nián lěi yuè',
  积日累久: 'jī rì lěi jiǔ',
  积日累月: 'jī rì lěi yuè',
  积日累岁: 'jī rì lěi suì',
  积时累日: 'jī shí lěi rì',
  积素累旧: 'jī sù lěi jiù',
  积岁累月: 'jī suì lěi yuè',
  积铢累寸: 'jī zhū lěi cùn',
  赍志而没: 'jī zhì ér mò',
  稽古揆今: 'jī gǔ zhèn jīn',
  激薄停浇: 'jī bó tíng jiāo',
  及宾有鱼: 'jí bīn yoǔ yú',
  及时行乐: 'jí shí xíng lè',
  吉人天相: 'jí rén tiān xiàng',
  极深研几: 'jí shēn yán jī',
  极深研幾: 'jí shēn yán jī',
  亟疾苛察: 'jí jí kē chá',
  急公好施: 'jí gōng hào shī',
  急功好利: 'jí gōng hào lì',
  急公好义: 'jí gōng hào yì',
  急景凋年: 'jí yǐng diāo nián',
  急脉缓灸: 'jí mài huǎn jiù',
  疾不可为: 'jí bù kě wéi',
  集腋为裘: 'jí yè wéi qiú',
  几不欲生: 'jī bù yù shēng',
  虮虱相吊: 'jǐ shī xiēng diào',
  掎裳连袂: 'jǐ cháng lián mèi',
  掎裳连襼: 'jǐ shang lián zhēng',
  计斗负才: 'jì dòu fù cái',
  计功量罪: 'jì gōng liàng zuì',
  计功行封: 'jì gōng xíng fēng',
  计深虑远: 'jì shēng lǜ yuǎn',
  计行虑义: 'jì xíng lǜ yì',
  计行言听: 'jì xíng yán tīng',
  纪纲人论: 'jì gāng rén lún',
  哜哜嘈嘈: 'jì jì cáo cáo',
  济济一堂: 'jǐ jǐ yī táng',
  寄兴寓情: 'jì xìng yù qíng',
  霁风朗月: 'jī fēng lǎng yuè',
  霁月光风: 'jī yuè guāng fēng',
  夹层玻璃: 'jiā céng bō li',
  夹袋人物: 'jiā dài rén wù',
  夹七夹八: 'jiā qī jiā bā',
  夹枪带棒: 'jiā qiāng dài bàng',
  夹枪带棍: 'jiā qiāng dài gùn',
  家长礼短: 'jiā cháng lǐ duǎn',
  家长里短: 'jiā cháng lǐ duǎn',
  家道从容: 'jiā dào cōng róng',
  家给民足: 'jiā jǐ mín zú',
  家给人足: 'jiā jǐ rén zú',
  家累千金: 'jiā lèi qiān jīn',
  家无担石: 'jiā wú dàn shí',
  家无斗储: 'jiā wú dòu chǔ',
  葭莩之亲: 'jiā fú zhī qīn',
  嘉言懿行: 'jiā yán yì xíng',
  甲冠天下: 'jiǎ guàn tiān xià',
  假洋鬼子: 'jiǎ yáng guǐ zi',
  尖嘴薄舌: 'jiān zuǐ bó shé',
  间不容发: 'jiān bù róng fà',
  间不容瞚: 'jiān bù róng xǐ',
  间不容息: 'jiàn bù róng xī',
  间见层出: 'jiàn xiàn céng chū',
  肩摩毂接: 'jiān mó gū jiē',
  艰难竭蹶: 'jiān nán jié jué',
  俭不中礼: 'jiǎn bù zhòng lǐ',
  剪发被褐: 'jiǎn fā bèi hè',
  剪发披缁: 'jiǎn fā pī zī',
  简明扼要: 'jiǎn míng é yào',
  简丝数米: 'jiǎn sī shǔ mǐ',
  见弹求鹗: 'jiàn dàn qiú è',
  见弹求鸮: 'jiàn dàn qiú háo',
  见缝就钻: 'jiàn fèng jiù zuān',
  见机而行: 'jiàn jī ér xíng',
  见几而作: 'jiàn jī ér zuò',
  见幾而作: 'jiàn jī ér zuò',
  见弃于人: 'jiàn qì yǔ rén',
  见素抱朴: 'xiàn sù bào pǔ',
  见所不见: 'jiàn suǒ bù jiàn',
  见义必为: 'jiàn yì bì wéi',
  见义当为: 'jiàn yì dāng wéi',
  见义敢为: 'jiàn yì gǎn wéi',
  见义勇为: 'jiàn yì yǒng wéi',
  剑首一吷: 'jiàn shǒu yī guī',
  渐不可长: 'jiàn bù kě zhǎng',
  鉴影度形: 'jiàn yǐng duó xíng',
  槛花笼鹤: 'jiàn huā lóng hè',
  江翻海倒: 'jiāng fān hǎi dǎo',
  江汉朝宗: 'jiāng hàn cháo zōng',
  江河行地: 'jiāng hé xíng dì',
  江左夷吾: 'jiāng zuǒ yí wú',
  将伯之呼: 'qiāng bó zhī hū',
  将伯之助: 'qiāng bó zhī zhù',
  将夺固与: 'jiāng duó gū yǔ',
  将功折过: 'jiāng gōng shé guò',
  将门有将: 'jiàng mén yǒu jiàng',
  将取固予: 'jiāng qǔ gū yǔ',
  将相之器: 'jiàng xiàng zhī qì',
  将遇良材: 'jiàng yù liáng cái',
  降龙伏虎: 'xiáng lóng fú hǔ',
  降妖捉怪: 'xiáng yāo zhuō guài',
  浇风薄俗: 'jiāo fēng bó sú',
  骄儿騃女: 'jiāo ér bā nǚ',
  骄奢淫泆: 'jiāo shē yín yí',
  骄泰淫泆: 'jiāo tai yín zhuàng',
  胶鬲之困: 'jiāo gé zhī kùn',
  焦唇干舌: 'jiāo chún gàn shé',
  焦沙烂石: 'jiāo shā shí làn',
  燋头烂额: 'jiāo tóu làn é',
  燋金烁石: 'jiāo jīn shuò shí',
  角立杰出: 'jiao li jie chu',
  挢抂过正: 'jiǎo kuāng guò zhèng',
  皎阳似火: 'jiǎo yáng shì huǒ',
  矫国更俗: 'jiǎo guó gēng sú',
  矫矫不群: 'jiǎo jiǎo bù qùn',
  矫情饰行: 'jiǎo qíng shì xíng',
  矫言伪行: 'jiǎo yán wěi xíng',
  较瘦量肥: 'jiào shòu liàng féi',
  教猱升木: 'jiāo náo shēng mù',
  教学相长: 'jiào xué xiāng zhǎng',
  教一识百: 'jiāo yī shí bǎi',
  诘曲聱牙: 'jié qǔ áo yá',
  诘屈磝碻: 'jié qū bìng zhòu',
  诘屈謷牙: 'jié qū dà yá',
  洁身累行: 'jié shēn lèi xíng',
  洁身自好: 'jié shēn zì hào',
  结结巴巴: 'jiē jiē bā bā',
  桀骜不恭: 'jié ào bù gōng',
  桀骜不驯: 'jié ào bù xùn',
  桀骜不逊: 'jié ào bù xùn',
  桀骜难驯: 'jié ào nán xùn',
  截铁斩钉: 'jié tiě zhǎn dìng',
  解发佯狂: 'jiě fà yáng kuáng',
  解铃系铃: 'jiě líng jì líng',
  解人难得: 'jiě rén nán dé',
  解衣衣人: 'jiè yī yī rén',
  戒奢宁俭: 'jiè shē nìng jiān',
  借公行私: 'jiè gōng xíng sī',
  金蝉脱壳: 'jīn chán tuō qiào',
  金翅擘海: 'jīn chì bāi hǎi',
  金匮石室: 'jīn guì shí shì',
  金吾不禁: 'jīn wú bù jìn',
  金相玉式: 'jīn xiāng yù shì',
  金相玉映: 'jīn xiāng yù yìng',
  金相玉振: 'jīn xiāng yù zhèn',
  金针见血: 'jīn zhēn jiàn xuè',
  津关险塞: 'jīn guān xiǎn sài',
  矜功不立: 'jīn gōng bù lì',
  矜才使气: 'jīn cái shǐ qì',
  矜功伐能: 'jīn gōng fá néng',
  矜功伐善: 'jīn gōng fá shàn',
  矜功负气: 'jīn gōng fǔ qì',
  矜功恃宠: 'jīn gōng shì chǒng',
  矜功自伐: 'jīn gōng zì fá',
  矜己自饰: 'jīn jǐ zhì shì',
  矜纠收缭: 'jīn jiū shōu liáo',
  矜名妒能: 'jīn míng dù néng',
  矜名嫉能: 'jīn míng jì néng',
  矜能负才: 'jīn néng fù cái',
  矜贫救厄: 'jīn pín jiù è',
  矜贫恤独: 'jīn pín xù dú',
  矜愚饰智: 'jīn yú shì zhì',
  矜智负能: 'jīn zhì fù néng',
  矜平躁释: 'jīn píng zào shì',
  谨行俭用: 'jǐn xíng jiǎn yòng',
  锦囊还矢: 'jǐn náng huán shǐ',
  锦衣行昼: 'jǐn yī xíng zhòu',
  尽多尽少: 'jǐn duō jǐn shǎo',
  尽力而为: 'jìn lì ér wéi',
  进寸退尺: 'jǐn cùn tuì chǐ',
  进退跋疐: 'jìn tuì bá zǔ',
  进退出处: 'jìn tuì chū chǔ',
  进退触籓: 'jìn tuì chù zǔ',
  进退两难: 'jǐn tuì liǎng nán',
  进退维亟: 'jìn tuì wéi jí',
  进退应矩: 'jìn tuì yīng jǔ',
  进退消长: 'jìn tuì xiāo cháng',
  进退中度: 'jìn tuì zhòng dù',
  进种善群: 'jìn zhǒng shàn qún',
  祲威盛容: 'lóng wēi shèng róng',
  禁舍开塞: 'jìn shě kāi sāi',
  禁止令行: 'jìn zhǐ lìng xíng',
  噤口捲舌: 'jìn kǒu juǎn shé',
  经纶济世: 'jing lun ji shi',
  经明行修: 'jīng míng xíng xiū',
  经年累月: 'jīng nián lěi yuè',
  荆棘塞途: 'jīng jí sè tú',
  荆棘载途: 'jīng jí zài tú',
  荆人涉澭: 'jīng rén shè yōng',
  惊魂落魄: 'jīng hún luò pò',
  旌旗卷舒: 'jīng qí juǎn shū',
  井底虾蟆: 'jǐng dǐ xiā má',
  径行直遂: 'jìng xíng zhí suí',
  敬业乐群: 'jìng yè yào qún',
  九间朝殿: 'jiǔ jiān cháo diàn',
  九蒸三熯: 'jiǔ zhēng sān shēng',
  九转功成: 'jiǔ zhuàn gōng chéng',
  久要不忘: 'jiǔ yāo bù wàng',
  灸艾分痛: 'jiù ài fēn tòng',
  旧地重游: 'jiù dì chóng yóu',
  旧调重弹: 'jiù diào chóng tán',
  旧事重提: 'jiù shì zhòng tí',
  咎有应得: 'jiù yǒu yīng dé',
  救过补阙: 'jiù guò bǔ quē',
  救苦救难: 'jiù kǔ jiù nàn',
  居不重席: 'jū bù chóng xí',
  居不重茵: 'jū bù chóng yīn',
  居下讪上: 'jú xià shàn shàng',
  居轴处中: 'jū zhóu chǔ zhōng',
  拘神遣将: 'jū shén qiǎn jiàng',
  鞠为茂草: 'jū wéi mào cǎo',
  鞫为茂草: 'jū wéi mào cǎo',
  橘化为枳: 'jú huà wéi zhǐ',
  举世混浊: 'jǔ shì hún zhuó',
  举手相庆: 'jǔ shǒu xiāng qìng',
  矩步方行: 'jǔ bù fāng xíng',
  据为己有: 'jù wéi jǐ yǒu',
  锯牙钩爪: 'jù yá gōu zhǎo',
  聚米为谷: 'jù mǐ wéi gǔ',
  聚米为山: 'jù mǐ wéi shān',
  卷甲倍道: 'juǎn jiǎ bèi dào',
  卷旗息鼓: 'juǎn qí xī gǔ',
  卷土重来: 'juǎn tǔ chóng lái',
  卷席而葬: 'juǎn xí ér zàng',
  倦鸟知还: 'juàn niǎo zhī huán',
  撅天扑地: 'juē tiān pū dì',
  倔头倔脑: 'juè tou juè nǎo',
  倔头强脑: 'juè tóu jiàng nǎo',
  嚼穿龈血: 'jiáo chuān yín xuè',
  嚼墨喷纸: 'jué mò pēn zhǐ',
  嚼铁咀金: 'jiáo tiě jǔ jīn',
  攫为己有: 'jué wéi jǐ yǒu',
  军不血刃: 'jūn bù xuè rèn',
  君子好逑: 'jūn zǐ hào qiú',
  钧天广乐: 'jūn tiān guǎng yuè',
  麇骇雉伏: 'jūn hài zhì fú',
  峻阪盐车: 'jùn bǎn yún chē',
  开花结实: 'kāi huā jié shí',
  开华结果: 'kāi huā jié guǒ',
  埳井之蛙: 'kǎn jǐng zhī wā',
  糠豆不赡: 'kang dou bu shan',
  抗颜为师: 'kàng yán wéi shī',
  咳唾成珠: 'ké tuò chéng zhū',
  咳珠唾玉: 'ké zhū tuò yù',
  可发一噱: 'kě fā yī jué',
  克什米尔: 'kè shí mǐ ěr',
  刻木为鹄: 'kè mù wéi hú',
  刻木为吏: 'kè mù wéi lì',
  嗑牙料嘴: 'kē yá liào zuǐ',
  空腹便便: 'kōng fù pián pián',
  抠心挖血: 'kōu xīn wā xuè',
  口碑载道: 'kǒu bēi zài dào',
  口出大言: 'kǒu chū dā yán',
  口腹之累: 'kǒu fù zhī lěi',
  口干舌焦: 'kǒu gàn shé jiāo',
  口角风情: 'kǒu jiǎo fēng qíng',
  口角春风: 'kǒu jiǎo chūn fēng',
  口角生风: 'kǒu jiǎo shēng fēng',
  口轻舌薄: 'kǒu qīng shé bó',
  口吐珠玑: 'kǒu tǔ zhū jī',
  口血未干: 'kǒu xuè wèi gān',
  枯树生华: 'kū shù shēng huā',
  哭丧着脸: 'kū sāng zhe liǎn',
  苦中作乐: 'kǔ zhōng zuò lè',
  夸多斗靡: 'kuā duō dòu mí',
  宽大为怀: 'kuān dà wéi huái',
  宽豁大度: 'kuān huō dà dù',
  匡救弥缝: 'kuāng jiù mí fèng',
  匡其不逮: 'kuāng qí bù dǎi',
  旷日累时: 'kuàng rì lěi shí',
  旷若发蒙: 'kuàng ruò fā méng',
  亏心短行: 'kuī xīn duǎn xíng',
  窥间伺隙: 'kuī jiàn sì xì',
  揆理度情: 'kuí lǐ duó qíng',
  揆情度理: 'kuí qíng duó lǐ',
  魁梧奇伟: 'kuí wǔ qí wěi',
  愧天怍人: 'kuì tiān zuò rén',
  困知勉行: 'kùn zhī miǎn xíng',
  困兽犹斗: 'kùn shòu yóu dòu',
  拉枯折朽: 'lā kū shé xiǔ',
  兰艾难分: 'lán ài nán fēn',
  兰艾同焚: 'lán ài tóng fén',
  阑风长雨: 'lán fēng zhàng yǔ',
  澜倒波随: 'lán dǎo bō suí',
  狼狈为奸: 'láng bèi wéi jiān',
  狼餐虎咽: 'láng cān hǔ yàn',
  狼飡虎咽: 'láng cān hǔ yān',
  狼号鬼哭: 'láng háo guǐ kū',
  狼飧虎咽: 'láng sūn hǔ yàn',
  狼吞虎咽: 'láng tūn hǔ yàn',
  狼心狗行: 'láng xīn gǒu xíng',
  琅嬛福地: 'láng huán fú dì',
  唠唠叨叨: 'lāo lāo dāo dāo',
  牢什古子: 'láo shí gǔ zi',
  老调重弹: 'lǎo diào zhòng dàn',
  老调重谈: 'lǎo diào chóng tán',
  老师宿儒: 'lǎo shī xiǔ rú',
  潦原浸天: 'lǎo yuán jìn tiān',
  乐道好古: 'lè dào hǎo gǔ',
  乐山乐水: 'yào shān yào shuǐ',
  乐善好施: 'lè shàn hào shī',
  乐行忧违: 'lè xíng yōu wéi',
  磊落豪横: 'lěi luò háo héng',
  累牍连篇: 'lěi dú lián piān',
  累及无辜: 'lěi jí wú gū',
  累教不改: 'lěi jiào bù gǎi',
  累块积苏: 'lěi kuài jī sū',
  累累如珠: 'lěi lěi rú zhū',
  累卵之危: 'lěi luǎn zhī wēi',
  累苏积块: 'lěi sū jī kuài',
  累土聚沙: 'lěi tǔ jù shā',
  累土至山: 'lěi tǔ zhì shān',
  累瓦结绳: 'lěi wǎ jié shéng',
  累屋重架: 'lěi wū chóng jià',
  累月经年: 'lěi yuè jīng nián',
  累足成步: 'lěi zú chéng bù',
  擂天倒地: 'léi tiān dǎo dì',
  楞眉横眼: 'lèng méi héng yǎn',
  冷水浇头: 'lěng shuǐ jiāo tóu',
  冷血动物: 'lěng xuè dòng wù',
  梨眉艾发: 'lí méi ài fā',
  离本徼末: 'lí běn yāo mò',
  离本趣末: 'lí běn qū mò',
  离山调虎: 'lí shān diào hǔ',
  犁牛骍角: 'lí niú mài jiǎo',
  犁生骍角: 'lí shēng yuè jiǎo',
  犁庭扫闾: 'lí tíng sǎo lǚ',
  礼崩乐坏: 'lǐ bēng yuè huài',
  礼坏乐崩: 'lǐ huài yuè bēng',
  礼让为国: 'lǐ ràng wéi guó',
  礼为情貌: 'lǐ wéi qíng mào',
  李广不侯: 'lǐ guǎng bù hòu',
  哩哩啦啦: 'li li lā lā',
  哩哩罗罗: 'li li luō luō',
  力有未逮: 'lì yǒu wèi dǎi',
  历精更始: 'lì jīng gèng shǐ',
  历精为治: 'lì jīng wéi zhì',
  历历可数: 'lì lì kě shǔ',
  立身行己: 'lì shēn xíng jǐ',
  利令志惛: 'lì lìng zhì zào',
  沥血披肝: 'lì xuè pī gān',
  沥血叩心: 'lì xuè kòu xīn',
  沥血披心: 'lì xuè pī xīn',
  栎阳雨金: 'lì yáng yǔ jīn',
  詈夷为跖: 'lì yí wéi zhí',
  连编累牍: 'lián biān lěi dú',
  连街倒巷: 'lián jiē dǎo xiàng',
  连篇累牍: 'lián piān lěi dú',
  连中三元: 'lián zhòng sān yuán',
  联篇累牍: 'lián piān lěi dú',
  敛骨吹魂: 'liǎn gǔ chuí hún',
  敛声屏息: 'liǎn shēng píng xī',
  恋恋难舍: 'liàn liàn nán shě',
  梁孟相敬: 'liáng mèng xiāng jìn',
  两虎相斗: 'liǎng hǔ xiāng dòu',
  两鼠斗穴: 'liǎng shǔ dòu xué',
  量才而为: 'liàng cái ér wéi',
  量才录用: 'liàng cái lù yòng',
  量才器使: 'liàng cái qì shǐ',
  量材录用: 'liàng cái lù yòng',
  量己审分: 'liàng jǐ shěn fēn',
  量金买赋: 'liàng jīn mǎi fù',
  量力度德: 'liàng lì duó dé',
  量力而为: 'liàng lì ér wéi',
  量力而行: 'liàng lì ér xíng',
  量如江海: 'liàng rú jiāng hǎi',
  量入为出: 'liàng rù wéi chū',
  量入计出: 'liàng rù jì chū',
  量枘制凿: 'liàng ruì zhì záo',
  量时度力: 'liàng shí dù lì',
  量体裁衣: 'liàng tǐ cái yī',
  量小力微: 'liàng xiǎo lì wēi',
  量凿正枘: 'liàng záo zhèng ruì',
  寥寥可数: 'liáo liáo kě shǔ',
  撩蜂吃螫: 'liáo fēng chī shì',
  撩蜂剔蝎: 'liáo fēng tì xiē',
  燎发摧枯: 'liǎo fà cuī kū',
  燎如观火: 'liǎo rú guān huǒ',
  蓼虫忘辛: 'liǎo chóng wàng xīn',
  了不长进: 'liǎo bù zhǎng jǐn',
  了不可见: 'liǎo bù kě jiàn',
  了然无闻: 'le rán wú wén',
  了如指掌: 'liǎo rú zhǐ zhǎng',
  了身达命: 'liǎo shēn dá mìng',
  了若指掌: 'liǎo ruò zhǐ zhǎng',
  了无惧色: 'liǎo wū jǔ sè',
  埒才角妙: 'liè cái jué miào',
  裂冠毁冕: 'liè guàn huǐ miǎn',
  裂裳裹足: 'liè cháng guǒ zú',
  裂裳衣疮: 'liè sháng yī chuāng',
  临敌易将: 'lín dí yì jiàng',
  临难不避: 'lín nán bù bì',
  临难不惧: 'lín nàn bù jǔ',
  临难无慑: 'lín nán wú shè',
  临深履薄: 'lín shēn lǚ bó',
  临潼斗宝: 'lín tóng dòu bǎo',
  赁耳佣目: 'lìn ěr yōng mù',
  陵劲淬砺: 'líng jìng cuì lì',
  零零散散: 'líng líng sǎn sǎn',
  令不虚行: 'lìng bù xū xíng',
  令人捧腹: 'lìng rén pěng fǔ',
  令行禁止: 'lìng xíng jìn zhǐ',
  令行如流: 'lìng xíng rú liú',
  令原之戚: 'líng yuán zhī qī',
  流离颠疐: 'liú lí diān shǔ',
  流水朝宗: 'liú shuǐ cháo zōng',
  流水行云: 'liú shuǐ xíng yún',
  流血漂卤: 'liú xuè piāo lǔ',
  流血千里: 'liú xuè qiān lǐ',
  柳骨颜筋: 'jiǔ gǔ yán jīn',
  柳街花巷: 'liǔ jiē huā xiòng',
  柳巷花街: 'liǔ xiòng huā jiē',
  六尺之讬: 'liù chǐ zhī quàn',
  六神不安: 'liù shén bǔ ān',
  龙雏凤种: 'lóng chú fèng zhǒng',
  龙雕凤咀: 'lóng diāo fèng jǔ',
  龙生九种: 'lóng shēng jiǔ zhǒng',
  龙行虎变: 'lóng xíng hǔ biàn',
  龙行虎步: 'lóng xíng hǔ bù',
  龙血凤髓: 'lóng xuè fèng suǐ',
  龙血玄黄: 'lóng xuě xuán huáng',
  龙游曲沼: 'long you qu zhao',
  龙争虎斗: 'lóng zhēng hǔ dòu',
  笼络人心: 'lǒng luò rén xīn',
  笼鸟池鱼: 'lóng niǎo shi yú',
  笼鸟槛猿: 'lóng niǎo jiàn yuán',
  漏尽更阑: 'lòu jìn gēng lán',
  露面抛头: 'lù miàn pāo tóu',
  鲁斤燕削: 'lǔ jīn yàn xuē',
  鹭序鸳行: 'lù xù yuān xíng',
  鹭序鹓行: 'lù xù yuān xíng',
  驴唇马觜: 'lǘ chún mǎ zī',
  屡教不改: 'lǚ jiàn bù gǎi',
  履薄临深: 'lǚ bó lín shēn',
  率尔操觚: 'shuài ér cāo gū',
  率尔成章: 'shuài ěr chéng zhāng',
  率马以骥: 'shuài mǎ yǐ jì',
  率土归心: 'shuài tǔ guī xīn',
  率兽食人: 'shuài shòu shí rén',
  率土同庆: 'shuài tǔ tóng qìng',
  率土宅心: 'shuài tǔ zhái xīn',
  率以为常: 'shuài yǐ wéi cháng',
  率由旧则: 'shuài yóu jiù zé',
  率由旧章: 'shuài yóu jiù zhāng',
  绿林大盗: 'lù lín dà dào',
  绿林豪杰: 'lù lín háo jié',
  绿林好汉: 'lù lín hǎo hàn',
  绿林豪士: 'lù lín háo shì',
  绿林豪客: 'lù lín háo kè',
  绿林强盗: 'lù lín qiáng dào',
  绿女红男: 'lǜ nǚ hóng nán',
  绿叶成荫: 'lǜ yè chéng yīn',
  鸾颠凤倒: 'luán diān fèng dǎo',
  鸾凤和鸣: 'luán fèng hè míng',
  鸾漂凤泊: 'luán piāo fèng bó',
  鸾飘凤泊: 'luán piāo fèng bó',
  鸾跂鸿惊: 'luán qí hóng jīng',
  卵与石斗: 'luǎn yǔ shí dòu',
  乱箭攒心: 'luàn jiàn cuán xīn',
  乱作胡为: 'luàn zuò hú wéi',
  论功行封: 'lùn gōng xíng fēng',
  论黄数黑: 'lùn huáng shǔ hēi',
  捋袖揎拳: 'luō xiù xuān quán',
  罗织构陷: 'luò zhī gòu xiàn',
  裸裎袒裼: 'luǒ chéng tǎn xī',
  落草为寇: 'luò cǎo wéi kòu',
  落落难合: 'luò luò nán hé',
  落魄不羁: 'luò pò bù jī',
  落魄不偶: 'luo tuo bu ou',
  落魄江湖: 'luò pò jīng hú',
  马入华山: 'mǎ rù huá shān',
  马上房子: 'mǎ shàng fáng zi',
  马咽车阗: 'mǎ yān chē tián',
  埋三怨四: 'mán sān yuàn sì',
  埋天怨地: 'mán tiān yuàn dì',
  买椟还珠: 'mǎi dú huán zhū',
  卖李钻核: 'mài lǐ zuān hé',
  卖俏行奸: 'mài qiào xíng jiān',
  卖文为生: 'mài wén wéi shēn',
  脉脉相通: 'mài mài xiāng tōng',
  满不在乎: 'mǎn bù zài hū',
  谩不经意: 'màn bù jīng yì',
  谩藏诲盗: 'màn cáng huì dào',
  谩辞哗说: 'màn cí huá shuō',
  谩天谩地: 'màn tiān màn dì',
  漫天遍地: 'màn shān biàn dì',
  尨眉皓发: 'máng méi hào fà',
  猫鼠同处: 'māo shǔ tóng chǔ',
  毛发不爽: 'máo fā bù shuǎng',
  毛发倒竖: 'máo fā dǎo shù',
  毛发悚然: 'máo fā sǒng rán',
  毛发耸然: 'máo fā sǒng rán',
  毛遂堕井: 'máo suí duò jǐng',
  毛头小子: 'máo tóu xiǎo zi',
  茅塞顿开: 'máo sè dùn kāi',
  冒名接脚: 'mào míng jiě jiǎo',
  貌合行离: 'mào hé xíng lí',
  没颠没倒: 'méi diān méi dǎo',
  没金饮羽: 'mò jīn yǐn yǔ',
  没没无闻: 'mò mò wú wén',
  没世不渝: 'méi shì bù yú',
  没世穷年: 'méi shì qióng nián',
  没世无称: 'méi shì wú chēng',
  没世无闻: 'méi shì wú wén',
  没头苍蝇: 'méi tóu cāng ying',
  没头没尾: 'méi tóu mò wěi',
  没完没了: 'méi wán méi liǎo',
  没衷一是: 'mò zhōng yī shì',
  昧旦晨兴: 'mèi dàn chún xīng',
  门单户薄: 'mén dān hù bó',
  扪参历井: 'mén shēn lì jǐng',
  闷海愁山: 'mèn hǎi chóu shān',
  闷闷不乐: 'mèn mèn bù lè',
  蒙古人种: 'měng gǔ rén zhǒng',
  蒙头转向: 'mēng tóu zhuàn xiàng',
  孟什维克: 'mèng shí wéi kè',
  迷恋骸骨: 'mí liàn hài gǔ',
  迷迷糊糊: 'mí mí hu hū',
  靡靡之乐: 'mǐ mǐ zhī yuè',
  靡然从风: 'mǐ rán cóng fēng',
  靡衣偷食: 'mǐ yī tōu shí',
  靡衣媮食: 'mǐ yī tōu shí',
  靡有孑遗: 'mǐ yǒu jié yí',
  绵里薄材: 'mián lǐ bó cái',
  绵力薄材: 'mián lì bó cái',
  黾穴鸲巢: 'měng xué qú cháo',
  俛首帖耳: 'mǎ shǒu tiē ěr',
  俛拾地芥: 'bì shí dì jiè',
  勉为其难: 'miǎn wéi qí nán',
  面折廷诤: 'miàn shé tíng zhèng',
  面折庭争: 'miàn shé tíng zhēng',
  邈处欿视: 'miǎo chǔ jī shì',
  灭景追风: 'miè yǐng zhuī fēng',
  名实相副: 'míng shí xiāng fù',
  名实相符: 'míng shí xiāng fú',
  名我固当: 'ming wo gu dang',
  明窗净几: 'míng chuāng jìng jī',
  明效大验: 'míng xiào dà yà',
  明争暗斗: 'míng zhēng àn dòu',
  鸣凤朝阳: 'míng fèng zhāo yáng',
  鸣鹤之应: 'míng hè zhī yīng',
  冥漠之都: 'míng mò zhī dōu',
  冥行盲索: 'míng xíng máng suǒ',
  冥行擿埴: 'míng xíng zhì zhí',
  冥昭瞢闇: 'míng zhāo méng àn',
  命薄缘悭: 'mìng báo yuán qiān',
  命中注定: 'mìng zhōng zhù dìng',
  缪种流传: 'miù zhǒng liú chuán',
  摸不着边: 'mō bù zhuó biān',
  摸门不着: 'mō mén bù zháo',
  摸头不着: 'mō tóu bù zháo',
  模模糊糊: 'mó mó hu hū',
  磨棱刓角: 'mó léng liǎng jiǎo',
  磨砻镌切: 'mó lóng juān qiē',
  磨牙吮血: 'mó yá shǔn xuè',
  抹粉施脂: 'mò fěn shī zhī',
  抹月秕风: 'mǒ yuè pī fēng',
  末节细行: 'mò jié xì xíng',
  莫此为甚: 'mò cǐ wéi shèn',
  莫为已甚: 'mò wéi yǐ shèn',
  莫予毒也: 'mò yù dú yě',
  莫知所为: 'mò zhī suǒ wéi',
  侔色揣称: 'móu sè chuǎi chèn',
  谋听计行: 'móu tīng jì xíng',
  谋为不轨: 'móu wéi bù guǐ',
  木干鸟栖: 'mù gàn niǎo qī',
  木头木脑: 'mù tóu mù nǎo',
  目不见睫: 'mù bù jiàn jié',
  目不暇给: 'mù bù xiá jǐ',
  目瞪舌彊: 'mù dèng shé jiàng',
  目量意营: 'mù liàng yì yíng',
  目空余子: 'mù kōng yú zǐ',
  目挑心招: 'mù tiǎo xīn zhāo',
  目窕心与: 'mù tiǎo xīn yǔ',
  目无尊长: 'mù wú zūn zhǎng',
  目眢心忳: 'mù yuān xīn wǎng',
  沐猴衣冠: 'mù hóu yī guàn',
  沐猴而冠: 'mù hóu ér guàn',
  牧猪奴戏: 'mù zhòu nú xì',
  暮楚朝秦: 'mù chǔ cháo qín',
  慕古薄今: 'mù gǔ bó jīn',
  暮爨朝舂: 'mù cuàn cháo chōng',
  暮翠朝红: 'mù cuì cháo hóng',
  暮鼓朝钟: 'mù gǔ cháo zhōng',
  暮去朝来: 'mù qù cháo lái',
  暮四朝三: 'mù sì cháo sān',
  暮想朝思: 'mù xiǎng cháo sī',
  拿粗夹细: 'ná cū jiā xì',
  拿腔作调: 'ná qiāng zuò diào',
  内峻外和: 'nèi jùn wai hé',
  内柔外刚: 'nèi róu wai gāng',
  内修外攘: 'nèi xiū wai rǎng',
  那么点儿: 'nà me diǎn er',
  纳新吐故: 'nà xīn tǔ gù',
  南贩北贾: 'nán fàn běi gǔ',
  南蛮鴂舌: 'nán mán xiāng shé',
  南腔北调: 'nán qiāng běi diào',
  南棹北辕: 'nán zhào běi yuán',
  难得糊涂: 'nán dé hú tú',
  难分难舍: 'nán fēn nán shě',
  难更仆数: 'nán gēng pú shǔ',
  难乎为情: 'nán hū wéi qíng',
  难乎为继: 'nán hū wéi jì',
  难进易退: 'nan jin yi tui',
  难舍难分: 'nán shě nán fēn',
  难兄难弟: 'nàn xiōng nàn dì',
  难以为情: 'nán yǐ wéi qíng',
  难以为继: 'nán yǐ wéi jì',
  囊萤照读: 'náng yíng zhào shū',
  挠直为曲: 'náo zhí wéi qū',
  讷言敏行: 'nè yán mǐn xíng',
  能不称官: 'néng bù chèn guān',
  能者为师: 'néng zhě wéi shī',
  泥而不滓: 'niè ér bù zǐ',
  泥名失实: 'nì míng shī shí',
  泥蟠不滓: 'ní pān bù zǐ',
  儗不于伦: 'lǐ bù yú lún',
  儗非其伦: 'nǐ fēi qí lún',
  逆耳利行: 'nì ěr lì xíng',
  逆施倒行: 'nì shī dǎo xíng',
  年华垂暮: 'nián huá thuí mù',
  年湮世远: 'nián yān shì yuǎn',
  年谊世好: 'nián yì shì hào',
  捻土为香: 'niǎn tǔ wéi xiāng',
  念念有词: 'niàn niàn yǒu cǐ',
  袅袅娜娜: 'niǎo niǎo nuó nuó',
  啮血沁骨: 'niè xuè qìn gǔ',
  啮血为盟: 'niè xuè wéi méng',
  蹑蹻担簦: 'niè juē dān dēng',
  孽障种子: 'niè zhàng zhǒng zǐ',
  宁缺毋滥: 'nìng quē wù làn',
  宁缺勿滥: 'nìng quē wù làn',
  宁死不屈: 'nìng sǐ bù qū',
  宁折不弯: 'nìng zhé bù wān',
  牛骥同皁: 'niú jì tóng wěn',
  扭直作曲: 'niǔ zhí zuò qū',
  扭转干坤: 'niǔ zhuǎn gàn kūn',
  浓抹淡妆: 'nóng mò dàn zhuāng',
  浓装艳抹: 'nóng zhuāng yàn mò',
  弄兵潢池: 'nòng bīng huáng shi',
  弄粉调朱: 'nòng fěn diào zhū',
  弄管调弦: 'nòng guǎn diào xián',
  弄口鸣舌: 'nòng kǒu míng shé',
  弄玉吹箫: 'nòng yù chuí xiāo',
  弄竹弹丝: 'nòng zhú dàn sī',
  怒发冲冠: 'nù fà chōng guān',
  女长当嫁: 'nǚ zhǎng dāng jià',
  女长须嫁: 'nǚ zhǎng xū jià',
  女大难留: 'nǚ dà nán liú',
  喏喏连声: 'nuò nuò lián shēng',
  呕心滴血: 'ǒu xīn dī xuè',
  呕心沥血: 'ǒu xīn lì xuè',
  偶一为之: 'ǒu yī wéi zhī',
  沤沫槿艳: 'ōu mò jǐn yàn',
  沤浮泡影: 'ōu fú pào yǐng',
  沤珠槿艳: 'ōu zhū jǐn yàn',
  排难解纷: 'pái nàn jiě fēn',
  排山倒海: 'pái shān dǎo hǎi',
  排忧解难: 'pái yōu jiě nàn',
  攀蟾折桂: 'pān chán shé guì',
  攀花折柳: 'pān huā shé liǔ',
  滂沱大雨: 'páng tuó dà yǔ',
  庞眉皓发: 'páng méi hào fà',
  旁通曲鬯: 'páng tōng qǔ chàng',
  旁通曲畅: 'páng tōng qǔ chàng',
  旁行斜上: 'páng xíng xié shàng',
  旁引曲证: 'páng yǐn qǔ zhèng',
  旁指曲谕: 'páng zhǐ qǔ yù',
  抛头露面: 'pāo tóu lù miàn',
  炮凤烹龙: 'páo fèng pēng lóng',
  炰鳖脍鲤: 'fèng biē kuài lǐ',
  跑马卖解: 'pǎo mǎ mài xiè',
  喷血自污: 'pēn xuè zì wū',
  喷云吐雾: 'pēn yún tǔ wù',
  烹龙炮凤: 'pēng lóng páo fèng',
  朋比为奸: 'péng bǐ wéi jiān',
  批风抹月: 'pī fēng mò yuè',
  批吭捣虚: 'pī háng dǎo xū',
  批隙导窾: 'pī xì dǎo yín',
  批砉导窾: 'pī huā dǎo táo',
  披发文身: 'pī fà wén shēn',
  披发缨冠: 'pī fā yīng guàn',
  披发入山: 'pī fā rù shān',
  披肝沥血: 'pī gān lì xuè',
  披心沥血: 'pī xīn lì xuè',
  噼里啪啦: 'pī lǐ pā lā',
  疲于奔命: 'pí yú bēn mìng',
  匹夫有责: 'pǐ fū yǒu zé',
  睥睨一切: 'pì nì yī qiè',
  片甲不还: 'piàn jiǎ bù huán',
  片鳞半爪: 'piàn lín bàn zhǎo',
  片言只语: 'piàn yán zhǐ yǔ',
  片言只字: 'piàn yán zhǐ zì',
  片语只辞: 'piàn yán zhǐ cí',
  片纸只字: 'piàn zhǐ yán zì',
  偏听偏信: 'piān tīng piāng xìn',
  翩翩年少: 'piān piān nián shǎo',
  骈肩累迹: 'pián jiān lěi jì',
  骈肩累足: 'pián jiān lěi zú',
  飘籓坠溷: 'piāo fān zhuì hùn',
  贫嘴薄舌: 'pín zuǐ bó shé',
  品竹调弦: 'pǐn zhú diào xián',
  娉婷婀娜: 'pīng tíng ē nà',
  平澹无奇: 'píng dàn wú qí',
  平铺直叙: 'píng pū zhí xù',
  凭几据杖: 'píng jī jù zhàng',
  屏气吞声: 'píng qì tūn shēng',
  屏声息气: 'bǐng shēng xī qì',
  帡天极地: 'jú tiān jí dì',
  萍飘蓬转: 'píng piāo péng zhuàn',
  瓶坠簪折: 'píng zhùi zān zhé',
  破愁为笑: 'pò chóu wéi xiào',
  破觚为圜: 'pò gū wéi yuán',
  破家为国: 'pò jiā wéi guó',
  破镜重合: 'pò jìng zhòng hé',
  破矩为圆: 'pò jǔ wéi yuán',
  破涕为笑: 'pò tì wéi xiào',
  仆仆亟拜: 'pú pú jí bài',
  铺锦列绣: 'pū jǐn liè xiù',
  铺眉蒙眼: 'pū méi méng yǎn',
  铺眉苫眼: 'pū méi shàn yǎn',
  铺胸纳地: 'pū xiōng nà dì',
  铺天盖地: 'pū tiān gài dì',
  普天率土: 'pǔ tiān shuài tǔ',
  七病八倒: 'qī bìng bā dǎo',
  七颠八倒: 'qī diān bā dǎo',
  七老八倒: 'qī lǎo bā dǎo',
  妻儿老少: 'qī ér lǎo shǎo',
  妻梅子鹤: 'qī mén zǐ hè',
  栖风宿雨: 'qī fēng xiǔ yǔ',
  期期艾艾: 'qī qī ài ài',
  欺天诳地: 'qī tiān kuāng dì',
  嘁哩喀喳: 'qī lǐ kā chā',
  齐量等观: 'qí liàng děng guān',
  齐王舍牛: 'qí wáng shě niú',
  其道亡繇: 'qí dào wáng yáo',
  奇葩异卉: 'qí pā yì hùi',
  耆德硕老: 'qí dé shuò lǎo',
  耆年硕德: 'qí nián shuò dé',
  骑驴倒堕: 'qí lǘ dǎo duò',
  棋输先著: 'qí shū xiān zhuó',
  棋高一着: 'qí gāo yī zhāo',
  棋输先着: 'qí shū xiān zhāo',
  綦溪利跂: 'qí xī lì guì',
  岂弟君子: 'kǎi tì jūn zǐ',
  启瞶振聋: 'qǐ guì zhèn lóng',
  起偃为竖: 'qǐ yǎn wéi shù',
  气冲斗牛: 'qì chōng dǒu niú',
  气克斗牛: 'qì kè dǒu niú',
  气息奄奄: 'qì xī yān yān',
  弃之度外: 'qì zhī dù wai',
  泣不成声: 'qǐ bù chéng shēng',
  泣下如雨: 'qǐ xià rú yǔ',
  恰如其分: 'qià rú qí fèn',
  千差万别: 'qiān chā wàn bié',
  千古绝调: 'qiān gǔ jué diào',
  千里一曲: 'qiān lǐ yī qǔ',
  千了百当: 'qiān liǎo bǎi dàng',
  千了万当: 'qiān le wàn dàng',
  千虑一得: 'qiān lǜ yī dé',
  千磨百折: 'qiān mó bǎi shé',
  千态万状: 'qiān tai wàn zhuàng',
  千载一弹: 'qiān zǎi yī dàn',
  千载一合: 'qiān zài yī hé',
  千状万态: 'qiān zhuàng wàn tai',
  千姿万态: 'qiān zī wàn tai',
  牵强附合: 'qiān qiáng fù hé',
  牵强附会: 'qiān qiáng fù huì',
  牵羊担酒: 'qiān yáng dàn jiǔ',
  搴旗取将: 'qiān qí qǔ jiàng',
  搴旗斩将: 'qiān qí zhǎn jiàng',
  前跋后疐: 'qián bá hòu máo',
  前仆后继: 'qián pū hòu jì',
  前言往行: 'qián yán wǎng xíng',
  潜德秘行: 'qián dé mì xíng',
  潜德隐行: 'qián dé yǐn xíng',
  遣兵调将: 'qiǎn bīng diào jiàng',
  遣将调兵: 'qiǎn jiāng diào bīng',
  遣兴陶情: 'qiǎn xìng táo qíng',
  枪林弹雨: 'qiāng lín dàn yǔ',
  强词夺理: 'qiǎng cí duó lǐ',
  强得易贫: 'qiǎng dé yì pín',
  强词夺正: 'qiǎng cí duó zhèng',
  强而后可: 'qiǎng ér hòu kě',
  强凫变鹤: 'qiǎng fú biàn hè',
  强干弱枝: 'qiáng gān ruò zhī',
  强聒不舍: 'qiǎng guō bù shě',
  强弓劲弩: 'qiáng gōng jìng nǔ',
  强识博闻: 'qiǎng shí bó wén',
  强食靡角: 'qiǎng shí mí jiǎo',
  强食自爱: 'qiǎng shí zì ài',
  强死赖活: 'qiǎng sǐ lài huó',
  强死强活: 'qiǎng sǐ qiǎng huó',
  强文假醋: 'qiǎng wén jiǎ cù',
  强文浉醋: 'qiǎng wén jiǎ cù',
  强直自遂: 'qiáng zhí zì suí',
  强自取折: 'qiáng zì qǔ shé',
  强嘴拗舌: 'jiàng zuǐ niù shé',
  强作解人: 'qiǎng zuò jiě rén',
  抢地呼天: 'qiāng dì hū tiān',
  敲骨剥髓: 'qiāo gǔ bāo suǐ',
  敲敲打打: 'qiāo qiāo dā dā',
  巧发奇中: 'qiǎo fā qí zhòng',
  翘足而待: 'qiáo zú ér dài',
  翘足引领: 'qiáo zú yǐn lǐng',
  鞘里藏刀: 'qiào lǐ cáng dāo',
  切瑳琢磨: 'qiē cùn zhuó mó',
  切近的当: 'qiē jìn de dāng',
  切理会心: 'qiē lǐ huì xīn',
  切理厌心: 'qiē lǐ yàn xīn',
  切理餍心: 'qiē lǐ yàn xīn',
  切切此布: 'qiè qiè cǐ bù',
  切切在心: 'qiè qiè zài xīn',
  切切私语: 'qiè qiè sī yǔ',
  切身体会: 'qiē shēn tǐ huì',
  切树倒根: 'qiē shù dǎo gēn',
  切中要害: 'qiē zhōng yào hài',
  且食蛤蜊: 'qiě shí há lí',
  且住为佳: 'qiě zhù wéi jiā',
  挈瓶之知: 'qiè píng zhī zhì',
  琴瑟之好: 'qí sè zhī hǎo',
  擒奸擿伏: 'qín jiān fā fú',
  螓首蛾眉: 'qín shǒu ér méi',
  寝苫枕干: 'qǐn shān zhěn gàn',
  青藏高原: 'qīng zàng gāo yuán',
  青红皁白: 'qīng hóng tóu bái',
  青林黑塞: 'qīng lín hēi sài',
  青紫被体: 'qīng zǐ pī tǐ',
  轻薄无礼: 'qīng báo wú lǐ',
  轻薄无行: 'qīng báo wú xíng',
  轻才好施: 'qīng cái hào shī',
  轻薄无知: 'qīng báo wú zhī',
  轻财好义: 'qīng cái hào yì',
  轻骑简从: 'qīng jì jiǎn cóng',
  轻吞慢吐: 'qīng tūn màn tǔ',
  轻傜薄赋: 'qīng yāo báo fù',
  轻繇薄赋: 'qīng yáo báo fù',
  轻重量级: 'qīng zhòng liàng jí',
  轻嘴薄舌: 'qīng zuǐ bó shé',
  倾肠倒肚: 'qīng cháng dào dǔ',
  倾心吐胆: 'qīng xīn tǔ dǎn',
  清辞丽曲: 'qīng cí lì qǔ',
  清都绛阙: 'qīng dōu jiàng què',
  清都紫府: 'qīng dōu zǐ fǔ',
  清都紫微: 'qīng dōu zǐ wēi',
  清风劲节: 'qīng fēng jìng jié',
  情非得已: 'qíng fēi dé yǐ',
  情见乎辞: 'qíng xiàn hū cí',
  情见力屈: 'qíng xiàn lì qū',
  情见势屈: 'qíng xiàn shì qū',
  情见埶竭: 'qíng jiàn zhōu jié',
  情凄意切: 'qíng qī yì qiē',
  穷年累世: 'qióng nián lěi shì',
  穷年累月: 'qióng nián lěi yuè',
  穷形尽相: 'qióng xíng jìn xiàng',
  秋实春华: 'qiū shí chūn huā',
  秋行夏令: 'qiū xíng xià líng',
  曲高和寡: 'qǔ gāo hè guǎ',
  曲不离口: 'qǔ bù lí kǒu',
  曲肱而枕: 'qǔ gōng ér zhěn',
  曲里拐弯: 'qū lǐ guǎn wān',
  曲眉丰颊: 'qǔ méi fēng jiá',
  曲曲折折: 'qū qū zhé shé',
  曲突移薪: 'qǔ tū yí xīn',
  曲学诐行: 'qǔ xué hǎo xíng',
  曲学阿世: 'qǔ xué ā shì',
  曲意承迎: 'qǔ yì chéng yíng',
  曲意奉迎: 'qǔ yì fèng yíng',
  曲意迎合: 'qǔ yì yíng hé',
  曲终奏雅: 'qǔ zhōng zòu yǎ',
  诎要桡腘: 'qū yào ráo yù',
  屈指可数: 'qū zhǐ kě shǔ',
  取青妃白: 'qǔ qīng fēi bái',
  取予有节: 'qǔ yù yǒu jié',
  去太去甚: 'qù tai qù shèn',
  圈牢养物: 'juàn láo yǎng wù',
  权倾中外: 'quán qīng zhōng wai',
  缺吃少穿: 'quē chī xhǎo chuān',
  却老还童: 'què lǎo huán tóng',
  却行求前: 'què xíng qiú qián',
  雀屏中选: 'què píng zhòng xuǎn',
  群雌粥粥: 'qún cí yù yù',
  群居穴处: 'qún jū xué chǔ',
  染须种齿: 'rǎn xū zhǒng chǐ',
  热熬翻饼: 'rě áo fān bǐng',
  人才济济: 'rén cái jǐ jǐ',
  人才难得: 'rén cái cái dé',
  人给家足: 'rén jǐ jiā zú',
  人莫予毒: 'rén mò yú dú',
  人模狗样: 'rén mú gǒu yàng',
  人生朝露: 'rén shēng cháo lù',
  人涉卬否: 'rén shè áng fǒu',
  人事不省: 'rén shì bù xǐng',
  人行横道: 'rén xíng héng dào',
  人言藉藉: 'rén yán jí jí',
  人自为战: 'rén zì wéi zhàn',
  人足家给: 'rén zú jiā jǐ',
  忍俊不住: 'rěn jùn bù zhù',
  忍俊不禁: 'rěn jùn bù jìn',
  认贼为子: 'rèn zéi wéi zǐ',
  认影为头: 'rèn yǐng wéi tóu',
  任达不拘: 'rèn láo bù jū',
  认贼为父: 'rèn zéi wéi fù',
  日薄西山: 'rì bó xī shān',
  日不暇给: 'rì bù xiá jǐ',
  日旰不食: 'rì gàn bù shí',
  日旰忘食: 'rì gàn wàng shí',
  日旰忘餐: 'rì gàn wàng cān',
  日积月累: 'rì jī yuè lěi',
  日省月课: 'rì xǐng yuè kè',
  日省月试: 'rì xǐng yuè shì',
  日削月朘: 'rì xuē yuè juān',
  日削月割: 'rì xuē yuè gē',
  日省月修: 'rì xǐng yuè xiū',
  日行千里: 'rì xíng qiān lǐ',
  日月参辰: 'rì yuè shēn chén',
  日昃旰食: 'rì zè gàn shí',
  日中必湲: 'rì zhōng bì tóng',
  日中为市: 'rì zhōng wéi shì',
  日朘月减: 'rì juān yuè jiǎn',
  日朘月削: 'rì juān yuè xuē',
  戎马劻勷: 'róng mǎ dān xiào',
  融为一体: 'róng wéi yī tǐ',
  柔情绰态: 'róu qíng chuō tai',
  柔茹刚吐: 'róu rú gāng tǔ',
  肉薄骨并: 'ròu bó gǔ bìng',
  如登春台: 'rú dé chūn tái',
  如履薄冰: 'rú lǚ bó bīng',
  如切如磋: 'rú qiē rú cuō',
  如数家珍: 'rú shǔ jiā zhēn',
  如水投石: 'rú shǔ tóu shí',
  如之奈何: 'rú zhī nai hé',
  茹毛饮血: 'rú máo yǐn xuè',
  茹柔吐刚: 'rú róu tǔ gāng',
  汝成人耶: 'nu cheng ren ye',
  乳臭未除: 'rǔ chòu wèi chú',
  辱国丧师: 'rǔ guó sàng shī',
  入理切情: 'rù lǐ qiē qíng',
  入铁主簿: 'rù tiě zhǔ bù',
  入土为安: 'rù tú wéi ān',
  入吾彀中: 'rù wǔ gòu zhōng',
  入孝出弟: 'rù xiào chū tì',
  软红香土: 'ruǎn hóng xiāng yù',
  撒豆成兵: 'sǎ dòu chéng bīng',
  洒扫应对: 'sǎ sào yìng duì',
  洒心更始: 'sǎ xīn gèng shǐ',
  塞井焚舍: 'sāi jǐng fén shě',
  塞翁得马: 'sài wēng dé mǎ',
  塞翁失马: 'sài wēng shī mǎ',
  塞翁之马: 'sài wēng zhī mǎ',
  三不拗六: 'sān bù niù liù',
  三差两错: 'sān chā liǎng cuò',
  三差五错: 'sān chā wǔ cuò',
  三朝五日: 'sān cháo wǔ rì',
  三朝元老: 'sān cháo yuán lǎo',
  三年五载: 'sān nián wǔ zài',
  三人为众: 'sān rén wèi zhòng',
  三省吾身: 'sān xǐng wú shēn',
  三思而行: 'sān sī ér xíng',
  三吐三握: 'sān tǔ sān wò',
  三瓦两舍: 'sān wǎ liǎng shě',
  三徙成都: 'sān xǐ chéng dōu',
  三灾八难: 'sān zāi bā nàn',
  三占从二: 'sān zhān cóng èr',
  三战三北: 'sān zhān sān běi',
  三座大山: 'sān zuò tài shān',
  桑户棬枢: 'sāng hù juàn shū',
  桑土绸缪: 'sāng tǔ chóu miù',
  桑荫不徙: 'sāng yīn bù xǐ',
  桑荫未移: 'sāng yīn wèi yí',
  丧胆销魂: 'sàng hún xiāo hún',
  丧魂落魄: 'sàng hún luò pò',
  色厉胆薄: 'sè lì dǎn bó',
  色仁行违: 'sè rén xíng wéi',
  杀鸡为黍: 'shā jī wéi shǔ',
  杀妻求将: 'shā qī qiú jiàng',
  杀衣缩食: 'shài yī suō shí',
  沙鸥翔集: 'sha ou xiang ji',
  歃血为盟: 'shà xuè wéi méng',
  山公倒载: 'shān gōng dǎo zǎi',
  山节藻棁: 'shān jié zǎo lì',
  山溜穿石: 'shān liù chuān shí',
  山行海宿: 'shān xíng hǎi xiǔ',
  山殽野湋: 'shān yāo yě fù',
  山阴乘兴: 'shān yīn chéng xīng',
  山止川行: 'shān zhǐ chuān xíng',
  山峙渊渟: 'shān zhì yuān zī',
  讪牙闲嗑: 'shàn yá xián kē',
  苫眼铺眉: 'shān yǎn pū méi',
  扇枕温被: 'shān zhěn wēn chuáng',
  扇枕温席: 'shān zhěn wēn xí',
  善财难舍: 'shàn cái nán shě',
  善贾而沽: 'shàn jià ér gū',
  善善恶恶: 'shàn shàn wù è',
  善为说辞: 'shàn wéi shuō cí',
  善自为谋: 'shàn zì wéi móu',
  赏不当功: 'shǎng bù dāng gōng',
  上当学乖: 'shàng dāng xué guāi',
  少不更事: 'shào bù gēng shì',
  少不经事: 'shào bù jīng shì',
  少成若性: 'shào chéng ruò xìng',
  少年老诚: 'shǎo nián lǎo chéng',
  蛇蝎为心: 'shé xiē wéi xīn',
  舍策追羊: 'shě cè zhuī yáng',
  舍己从人: 'shě jǐ cóng rén',
  舍短取长: 'shě duǎn qǔ cháng',
  舍近即远: 'shě jìn jí yuǎn',
  舍己为人: 'shě jǐ wèi rén',
  舍己为公: 'shě jǐ wèi gōng',
  舍近求远: 'shě jìn qiú yuǎn',
  舍近务远: 'shě jìn wù yuǎn',
  舍我其谁: 'shě wǒ qí shuí',
  舍身为国: 'shě shēn wéi guó',
  设身处地: 'shè shēn chǔ dì',
  设心处虑: 'shè xīn chǔ lǜ',
  身单力薄: 'shēn dān lì bó',
  身体发肤: 'shēn tǐ fà fū',
  身无长物: 'shēn wú cháng wù',
  身无择行: 'shēn wú zé xíng',
  身先朝露: 'shēn xiān cháo lù',
  深仇宿怨: 'shēn chóu xiǔ yuàn',
  深恶痛嫉: 'shēn wù tòng jí',
  深恶痛绝: 'shēn wù tòng jué',
  深恶痛疾: 'shēn wù tòng jí',
  深更半夜: 'shēn gēng bàn yè',
  深谷为陵: 'shēn gǔ wéi líng',
  深厉浅揭: 'shēn lì qiǎn qì',
  深切着白: 'shēn qiē zhe bái',
  深切着明: 'shēn qiē zhe míng',
  深文曲折: 'shēn wén qǔ shé',
  深文周内: 'shēn wén zhōu nà',
  神不收舍: 'shén bù shōu shě',
  神不守舍: 'shén bù shǒu shě',
  神差鬼使: 'shén chāi guǐ shǐ',
  神出鬼没: 'shén chū guǐ mò',
  神号鬼哭: 'shén háo guǐ kū',
  神龙失埶: 'shén lóng shī zhì',
  神武挂冠: 'shén wǔ guà guàn',
  沈博绝丽: 'chén bó jué lì',
  审己度人: 'shěn jǐ duó rén',
  审时度势: 'shěn shí duó shì',
  审曲面埶: 'shěn qǔ miàn xīn',
  生拖死拽: 'shēng tuō sǐ zhuāi',
  绳愆纠缪: 'sheng qian jiu miu',
  圣君贤相: 'shèng jīng xián xiàng',
  圣经贤传: 'shèng jīng xián zhuàn',
  盛水不漏: 'chéng shuǐ bù lòu',
  尸居龙见: 'shī jū lóng xiàn',
  失而复得: 'shī ér fù de',
  失魂落魄: 'shī hún luò pò',
  失马塞翁: 'shī mǎ sài wēng',
  师直为壮: 'shī zhí wéi zhuàng',
  虱处裈中: 'shī chǔ kūn zhōng',
  诗书发冢: 'shī shū fà zhǒng',
  施施而行: 'shī shī ér xíng',
  十不当一: 'shí bù huò yī',
  十夫楺椎: 'shí fū zhī zhuī',
  十魔九难: 'shí mó jiǔ nàn',
  什围伍攻: 'shí wéi wǔ gōng',
  什袭而藏: 'shí xī ér cáng',
  什伍东西: 'shí wǔ dōng xī',
  什袭以藏: 'shí xí yǐ cáng',
  什袭珍藏: 'shí xí zhēn cáng',
  石室金匮: 'shí shì jīn guì',
  石英玻璃: 'shí yīng bō li',
  时亨运泰: 'shí hēng yùn tai',
  时来运转: 'shí lái yùn zhuǎn',
  时运不齐: 'shí yùn bù jì',
  识微知著: 'shí wēi zhī zhuó',
  实偪处此: 'shí bèng chǔ cǐ',
  实逼处此: 'shí bī chǔ cǐ',
  实蕃有徒: 'shí fān yǒu tú',
  实与有力: 'shí yù yǒu lì',
  拾带重还: 'shí dài zhòng huán',
  拾掇无遗: 'shi duo wu yi',
  拾遗补阙: 'shí yí bǔ quē',
  食不下咽: 'shí bù xià yàn',
  食不重肉: 'shí bù zhóng ròu',
  食不重味: 'shí bù chóng wèi',
  食为民天: 'shí wéi mín tiān',
  使羊将狼: 'shǐ yáng jiàng láng',
  事与心违: 'shì yù xīn wéi',
  事在必行: 'shì zài bì xíng',
  势在必行: 'shì zài bì xíng',
  视而不见: 'shì ér bù jiàn',
  视微知著: 'shì wēi zhī zhuó',
  视为儿戏: 'shì wéi ér xì',
  视为寇雠: 'shì wéi kòu chóu',
  视为畏途: 'shì wéi wèi tú',
  视为知己: 'shì wéi zhī jǐ',
  饰非遂过: 'shì fēi suí guò',
  饰情矫行: 'shì qíng jiǎo xíng',
  饰智矜愚: 'shì zhì jīn yú',
  是非得失: 'shì fēi dé shī',
  是非分明: 'shì fēi fēn míng',
  是非曲直: 'shì fēi qǔ zhí',
  适当其冲: 'shì dāng qí chōng',
  适当其时: 'shì dāng qí shí',
  适居其反: 'shì jú qí fǎn',
  适情率意: 'shì qíng shuài yì',
  适如其分: 'shì rú qí fèn',
  适时应务: 'shì shí yīng wù',
  释知遗形: 'shì shì yí xíng',
  螫手解腕: 'shì shǒu jǐe wǎn',
  收因种果: 'shōu yīn zhǒng guǒ',
  手不应心: 'shǒu bù yīng xīn',
  手脚干净: 'shǒu jiǎo gàn jìng',
  手足异处: 'shǒu zú yì chǔ',
  手足重茧: 'shǒu zú chóng jiǎn',
  守分安常: 'shǒu fēn ān cháng',
  守土有责: 'shǒu tǔ yǒu zé',
  首足异处: 'shǒu zú yì chǔ',
  瘦骨嶙峋: 'shòu gǔ lí xún',
  瘦骨梭棱: 'shòu gǔ léng léng',
  书缺有间: 'shū quē yǒu jiàn',
  叔度陂湖: 'shū dù bēi hú',
  疏不间亲: 'shū bù jiàn qīn',
  束椽为柱: 'shù chuán wéi zhù',
  束发封帛: 'shù fā fēng bó',
  束带结发: 'shù dài jié fā',
  束蒲为脯: 'shù pú wéi pú',
  束身自好: 'shù shēn zì hào',
  束缊举火: 'shù yūn jǔ huǒ',
  束缊还妇: 'shù yūn huán fù',
  树碑立传: 'shù bēi lì zhuàn',
  树倒根摧: 'shù dǎo gēn cuī',
  数白论黄: 'shǔ bái lùn huáng',
  数不胜数: 'shǔ bù shèng shǔ',
  数典忘祖: 'shǔ diǎn wàng zǔ',
  数短论长: 'shǔ duǎn lùn cháng',
  数黑论黄: 'shǔ hēi lùn huáng',
  数黄道黑: 'shu huang dao hei',
  数见不鲜: 'shuò jiàn bù xiān',
  数理逻辑: 'shù lǐ luó ji',
  数米量柴: 'shǔ mǐ ér chái',
  数往知来: 'shǔ wǎng zhī lái',
  数米而炊: 'shǔ mǐ ér chuī',
  数一数二: 'shǔ yī shǔ èr',
  数以万计: 'shǔ yǐ wàn jì',
  双柑斗酒: 'shuài gān dǒu jiǔ',
  双足重茧: 'shuāng zú chóng jiǎn',
  霜行草宿: 'shuāng xíng cǎo xiǔ',
  爽心豁目: 'shuǎng xīn huō mù',
  水长船高: 'shuǐ zhǎng chuán gāo',
  水到鱼行: 'shuǐ dào yú xíng',
  水调歌头: 'shuǐ diào gē tóu',
  水米无干: 'shuǐ mǐ wú gàn',
  水宿风餐: 'shuǐ xiǔ fēng cān',
  水宿山行: 'shuǐ xiǔ shān xíng',
  水中著盐: 'shuǐ zhōng zhuó yán',
  水中捉月: 'shui zhong zhuo yue',
  顺风吹火: 'shǔn fēng chuī huǒ',
  顺风而呼: 'shǔn fēng ér hū',
  顺风使船: 'shǔn fēng shǐ chuán',
  顺风驶船: 'shǔn fēng shǐ chuán',
  顺风转舵: 'shǔn fēng zhuǎn duò',
  顺天应时: 'shùn tiān yīng shí',
  铄古切今: 'shuò gǔ qiē jīn',
  硕望宿德: 'shuò wàng xiǔ dé',
  槊血满袖: 'shuò xuè mǎn xiù',
  丝恩发怨: 'sī ēn fà yuàn',
  思所逐之: 'si shuo zhu zi',
  斯事体大: 'ī shì tǐ dà',
  死有余责: 'sǐ yǒu yú zé',
  四不拗六: 'sì bù niù liù',
  四海为家: 'sì hǎi wéi jiā',
  四马攒蹄: 'sì mǎ cuán tí',
  四亭八当: 'sì tíng bā dàng',
  騃女痴男: 'ái nǚ chī nán',
  騃童钝夫: 'ái tóng dùn fū',
  松筠之节: 'sōng jūn zhī jié',
  宋斤鲁削: 'sòng jīn lǔ xuē',
  薮中荆曲: 'sǒu zhōng jí qǔ',
  搜岩采干: 'sōu yán cǎi gàn',
  夙兴夜处: 'sù xīng yè chǔ',
  素隐行怪: 'sù yǐn xíng guài',
  宿水餐风: 'xiǔ shuǐ cān fēng',
  宿水飡风: 'xiǔ shuǐ cān fēng',
  宿雨餐风: 'xiǔ yǔ cān fēng',
  随风倒舵: 'suí fēng dǎo duò',
  随风而靡: 'suí fēng ér mǐ',
  随物应机: 'suí wù yīng jī',
  随行逐队: 'suí xíng zhú duì',
  岁聿其莫: 'suì yù qí mù',
  岁月不居: 'suì yuè bù jú',
  遂非文过: 'suí fēi wén guò',
  遂迷不寤: 'suí mí bù wù',
  遂迷不窹: 'suí méi bù wù',
  遂心应手: 'suì xīn yīng shǒu',
  睟面盎背: 'suì miàn àng bèi',
  损军折将: 'sǔn jūn zhé jiàng',
  损兵折将: 'sǔn bīng zhé jiàng',
  所作所为: 'suǒ zuò suǒ wéi',
  索隐行怪: 'suǒ yǐn xíng guài',
  狧穅及米: 'shì kǎn jí mǐ',
  骀背鹤发: 'dài bèi hè fā',
  太山北斗: 'tài shān běi dòu',
  泰极而否: 'tài jí ér pǐ',
  泰来否极: 'tai lái fǒu jí',
  泰来否往: 'tài lái pǐ wǎng',
  泰然处之: 'tài rán chǔ zhī',
  泰山盘石: 'tai shān pán shí',
  贪夫狥财: 'tān fū huái cái',
  贪夫狥利: 'tān fū yě lì',
  谈言微中: 'tán yán wēi zhòng',
  谭言微中: 'tán yán wēi zhòng',
  袒裼裸裎: 'tǎn xī luǒ chéng',
  叹为观止: 'tàn wéi guān zhǐ',
  探囊胠箧: 'tàn náng wú qiè',
  唐临晋帖: 'táng lín jìn tiē',
  堂皇冠冕: 'táng huáng guàn miǎn',
  桃蹊柳曲: 'táo qī liǔ qǔ',
  啼饥号寒: 'tí jī háo hán',
  蹄间三寻: 'tí jìan sān xún',
  蹄閒三寻: 'tí jiàn sān xún',
  替天行道: 'tì tiān xíng dào',
  天宝当年: 'tian bao dang nian',
  天兵天将: 'tiān bīng tiān jiàng',
  天差地远: 'tiān chā dì yuǎn',
  天道好还: 'tiān dào hǎo huán',
  天华乱坠: 'tiān huā luàn zhuì',
  天马行空: 'tiān mǎ xíng kōng',
  天年不遂: 'tiān nián bù suì',
  天台路迷: 'tiān tái lù mí',
  天下为公: 'tiān xià wéi gōng',
  天下为笼: 'tiān xià wéi lóng',
  天下为家: 'tiān xià wéi jiā',
  天旋地转: 'tiān xuán dì zhuàn',
  添砖加瓦: 'tiān zhuān jiē wǎ',
  恬不为怪: 'tián bù wéi guài',
  恬不为意: 'tián bù wéi yì',
  靦颜事仇: 'tiǎn yán shì chóu',
  挑唇料嘴: 'tiǎo chún liào zuǐ',
  挑么挑六: 'tiāo yāo tiāo liù',
  挑三豁四: 'tiāo sān huō sì',
  挑牙料唇: 'tiǎo yá liào chún',
  条贯部分: 'tiáo guàn bù fēn',
  铁板钉钉: 'tiě bǎn dìng dīng',
  铁绰铜琶: 'tiě chuō tóng pá',
  铁树开华: 'tiě shù kāi huā',
  听而不闻: 'tīng ér bú wén',
  停留长智: 'tíng liú zhǎng zhì',
  铤鹿走险: 'dìng lù zǒu xiǎn',
  通都大埠: 'tōng dōu dà bù',
  通都巨邑: 'tōng dōu jù yì',
  通同一气: 'tōng tóng yī yì',
  通文调武: 'tōng wén diào wǔ',
  通邑大都: 'tōng yì dà dōu',
  痌瘝在抱: 'tōng guān zào bào',
  同仇敌忾: 'tóng chóu dí kài',
  同恶相党: 'tóng è xiāng dǎng',
  同恶相济: 'tóng è xiāng jì',
  同恶相求: 'tóng è xiāng qiú',
  同恶相恤: 'tóng wù xiāng xù',
  同恶相助: 'tóng wù xiāng zhù',
  同工异曲: 'tóng gōng yì qǔ',
  同心僇力: 'tóng xīn jié lì',
  同源异派: 'tóng yuán yì pai',
  童颜鹤发: 'tóng yán hè fà',
  痛深恶绝: 'tòng shēn wù jué',
  痛自创艾: 'tòng zì chuāng yì',
  头出头没: 'tóu chū tóu mò',
  头会箕赋: 'tóu kuài jī fù',
  头会箕敛: 'tóu kuàn jī liǎn',
  头昏脑闷: 'tóu hūn nǎo mèn',
  头没杯案: 'tóu mò bēi àn',
  头破血淋: 'tóu pò xuè lín',
  头破血出: 'tóu pò xuè chū',
  头上著头: 'tóu shàng zhuó tóu',
  头足异处: 'tóu zú yì chǔ',
  投传而去: 'tóu zhuàn ér qù',
  投其所好: 'tóu qí suǒ hào',
  图穷匕见: 'tú qióng bǐ xiàn',
  徒讬空言: 'tú tún kōng yán',
  屠龙之伎: 'tú lóng zhī jì',
  屠门大嚼: 'tú mén dà jiáo',
  土生土长: 'tǔ shēng tǔ zhǎng',
  吐哺辍洗: 'tǔ bǔ chuò xǐ',
  吐哺握发: 'tǔ bǔ wò fà',
  吐哺捉发: 'tǔ bǔ zhuō fā',
  吐胆倾心: 'tǔ dǎn qīng xīn',
  吐肝露胆: 'tǔ gān lù dǎn',
  吐刚茹柔: 'tǔ gāng rú róu',
  吐故纳新: 'tǔ gù nà xīn',
  吐食握发: 'tǔ shí wò fā',
  吐丝自缚: 'tǔ sī zì fù',
  吐心吐胆: 'tǔ xīn tǔ dǎn',
  兔角龟毛: 'tu jiao gui mao',
  兔葵燕麦: 'tù kuí yàn mài',
  兔头麞脑: 'tù tóu suō nǎo',
  兔丝燕麦: 'tù sī yàn mài',
  兔走鹘落: 'tù zǒu gǔ luò',
  团头聚面: 'tuàn tóu jù miàn',
  剸繁决剧: 'shí fán jué jù',
  剸繁治剧: 'shí fán zhì jù',
  推干就湿: 'tuī gàn jiù shī',
  推枯折腐: 'tuī kū shé fǔ',
  颓垣断堑: 'tuí yuán duàn piàn',
  吞刀吐火: 'tūn dāo tǔ huǒ',
  吞吞吐吐: 'tūn tūn tǔ tǔ',
  吞言咽理: 'tūn yán yān lǐ',
  吞云吐雾: 'tūn yún tǔ wù',
  托公行私: 'tuō gōng xíng sī',
  妥首帖耳: 'tuǒ shǒu tiē ěr',
  蛙蟆胜负: 'wā má shèng fù',
  歪打正着: 'wāi dǎ zhèng zháo',
  歪歪倒倒: 'wāi wāi dǎo dǎo',
  外强中干: 'wài qiáng zhōng gān',
  外强中瘠: 'wài qiáng zhōng jí',
  刓方为圆: 'shū fāng wéi yuán',
  纨袴子弟: 'wán kǔ zǐ dì',
  玩儿不转: 'wán ér bù zhuàn',
  玩日愒时: 'wán rì kài shí',
  玩时愒日: 'wán shí ài rì',
  玩岁愒日: 'wán suì kài rì',
  玩岁愒时: 'wán suì yī shí',
  玩岁愒月: 'wán suì yī yuè',
  晚节不保: 'wǎn jíe bù bǎo',
  晚食当肉: 'wǎn shí dàng ròu',
  万别千差: 'wàn bié qiān chā',
  万夫不当: 'wàn fū bù dāng',
  万贯家私: 'wàn guàn ji sī',
  万箭攒心: 'wàn jiàn cuán xīn',
  万载千秋: 'wàn zài qiān qiū',
  亡国大夫: 'wáng guó dà fū',
  亡魂失魄: 'wáng hún shī hún',
  王不留行: 'wáng bù liú xíng',
  王贡弹冠: 'wáng gòng dàn guàn',
  王侯将相: 'wáng hóu jiàng xiàng',
  往渚还汀: 'wǎng zhǔ huán tīng',
  枉曲直凑: 'wǎng qǔ zhí còu',
  望尘僄声: 'wàng chén bù shēng',
  望风披靡: 'wàng fēng pī mǐ',
  望风响应: 'wàng fēng xiǎng yīng',
  望闻问切: 'wàng wén wèn qiē',
  望影揣情: 'wàng yǐng chuāi qíng',
  危如累卵: 'wēi rú lěi luǎn',
  危言危行: 'wēi yán wēi xíng',
  危于累卵: 'wēi yú lěi luǎn',
  威重令行: 'wēi zhòng lìng xíng',
  偎干就湿: 'wēi gàn jiù shī',
  微服私行: 'wēi fú sī xíng',
  煨干避湿: 'wēi gàn bì shī',
  煨干就湿: 'wēi gàn jiù shī',
  为德不终: 'wéi dé bù zhōng',
  为德不卒: 'wéi dé bù zú',
  为恶不悛: 'wéi è bù quān',
  为法自弊: 'wéi fǎ zì bì',
  为鬼为蜮: 'wéi guǐ wéi yù',
  为富不仁: 'wéi fù bù rén',
  为非作恶: 'wéi fēi zuò è',
  为非作歹: 'wéi fēi zuò dǎi',
  为国为民: 'wéi guó wéi mín',
  为好成歉: 'wéi hǎo chéng qiàn',
  为虺弗摧: 'wéi huǐ fú cuī',
  为民父母: 'wéi mín fù mǔ',
  为裘为箕: 'wéi qiú wéi jī',
  为人作嫁: 'wèi rén zuò jià',
  为人说项: 'wèi rén shuō xiàng',
  为仁不富: 'wéi rén bù fù',
  为山止篑: 'wéi shān zhǐ kuì',
  为蛇画足: 'wéi shé huà zú',
  为善最乐: 'wéi shàn zuì lè',
  为蛇添足: 'wéi shé tiān zú',
  为所欲为: 'wéi suǒ yù wéi',
  唯所欲为: 'wéi suǒ yù wéi',
  唯唯否否: 'wěi wěi fǒu fǒu',
  唯吾独尊: 'wéi wú dú zūn',
  帷薄不修: 'wéi bó bù xiū',
  惟妙惟肖: 'wéi miào wéi xiào',
  惟利是趋: 'wéi lì shì qú',
  惟日为岁: 'wéi rì wéi suì',
  惟所欲为: 'wéi suǒ yù wéi',
  嵬眼澒耳: 'wéi yǎn xiāng ěr',
  维妙维肖: 'wéi miào wéi xiào',
  尾大难掉: 'wěi dà nán diào',
  委曲成全: 'wěi qǔ chéng quán',
  委委佗佗: 'wēi wēi tuó tuó',
  萎靡不振: 'wěi mǐ bù zhèn',
  亹亹不倦: 'tān wěi bù juàn',
  未艾方兴: 'wèi ài fāng xīng',
  未为不可: 'wèi wéi bù kě',
  畏首畏尾: 'wèi shǒ wèi wěi',
  谓予不信: 'wèi yú bù xìn',
  蔚为大观: 'wèi wéi dà guān',
  温衾扇枕: 'wēn qīn shān zhěn',
  温凊定省: 'wēn qǐng dìng shěng',
  温席扇枕: 'wēn xí shān zhěn',
  温枕扇席: 'wēn zhěn shān xí',
  文不对题: 'wén bù duì tí',
  文房四侯: 'wén fáng sì hòu',
  文过遂非: 'wén guò suí fēi',
  文身剪发: 'wén shēn jiǎn fā',
  文武差事: 'wén wǔ chà shì',
  文行出处: 'wén xíng chū chǔ',
  文以载道: 'wén yǐ zài dào',
  文章山斗: 'wén zhāng shān dòu',
  文章星斗: 'wén zhāng xīng dòu',
  闻风响应: 'wén fēng xiǎng yīng',
  稳操胜券: 'wén cāo shèng quàn',
  稳操左券: 'wén cāo zuǒ quàn',
  蜗行牛步: 'wō xíng niú bù',
  我行我素: 'wǒ xíng wǒ sù',
  捰袖揎拳: 'luò xiù xuān quán',
  握发吐飧: 'wò fā tǔ sūn',
  握发吐哺: 'wò fā tǔ bǔ',
  握拳透爪: 'wò quán tòu zhǎo',
  握粟出卜: 'wò sù chū bo',
  诬良为盗: 'wū liáng wéi dào',
  无的放矢: 'wú dì fàng shǐ',
  无地自处: 'wú dì zì chǔ',
  无颠无倒: 'wú diān wú dǎo',
  无动为大: 'wú dòng wéi dà',
  无恶不为: 'wú è bù wéi',
  无缝天衣: 'wú féng tiān yī',
  无间冬夏: 'wú jiān dōng xià',
  无间可乘: 'wú jiān kě chéng',
  无间可伺: 'wú jiān kě sì',
  无精嗒彩: 'wú jīng dā cǎi',
  无胫而行: 'wú jìng ér xíng',
  无可比拟: 'wú kě bǐ nì',
  无孔不钻: 'wú kǒng bù zuān',
  无寇暴死: 'wu kou bào shi',
  无了无休: 'wú le wú xiū',
  无能为役: 'wú néng wéi yì',
  无能为力: 'wú néng wéi lì',
  无偏无陂: 'wú piān wú bēi',
  无伤大雅: 'wú shāng dà yǎ',
  无伤无臭: 'wú shēng wú xiù',
  无声无臭: 'wú shēng wú xiù',
  无適无莫: 'wú dí wú mò',
  无所不为: 'wú suǒ bù wéi',
  无下箸处: 'wú xià zhù chǔ',
  无与为比: 'wú yǔ wéi bǐ',
  吾谁与归: 'wú shuí yǔ guī',
  吾膝如铁: 'wú xī rú tiě',
  吾自有处: 'wu zi you chu',
  五尺之僮: 'wǔ chǐ zhī tóng',
  五羖大夫: 'wǔ gǔ dà fū',
  五侯蜡烛: 'wǔ hòu là zhú',
  五侯七贵: 'wǔ hòu qī guì',
  五脊六兽: 'wǔ jí liù shòu',
  五色相宣: 'wǔ sè xiāng xuān',
  五石六鹢: 'wǔ shí liù yī',
  五行八作: 'wǔ háng bā zuò',
  五行并下: 'wǔ háng bìng xià',
  五行生克: 'wǔ háng shēng kè',
  武断专横: 'wǔ duàn zhuān héng',
  碔砆混玉: 'zhì fū hùn yù',
  舞爪张牙: 'wǔ zhǎo zhāng yá',
  物竞天择: 'wù jìn tiān zé',
  物稀为贵: 'wù xī wéi guì',
  误作非为: 'wù zuò fēi wéi',
  雾鳞云爪: 'wù lín yún zhǎo',
  吸新吐故: 'xī xīn tǔ gù',
  析肝吐胆: 'xī gān tǔ dǎn',
  析圭儋爵: 'xī guī dān jué',
  悉索薄赋: 'xī suǒ bó fù',
  晰毛辨发: 'xī máo biàn fà',
  歙漆阿胶: 'shè qī ē jiāo',
  习焉不察: 'xī yān bù chá',
  喜怒哀乐: 'xǐ nù āi lè',
  喜行于色: 'xǐ xíng yú sè',
  虾兵蟹将: 'xiā bīng xiè jiàng',
  下不为例: 'xià bù wéi lì',
  先睹为快: 'xiān dǔ wéi kuài',
  先我着鞭: 'xiān wǒ zhuó biān',
  闲愁万种: 'xián chóu wàn zhǒng',
  挦章撦句: 'lóng zhāng zōng jù',
  相差无几: 'xiāng chā wú jǐ',
  相得甚欢: 'xiāng dé shèn huān',
  相辅而行: 'xiāng fǔ ér xíng',
  相机行事: 'xiāng jī xíng shì',
  相门有相: 'xiàng mén yǒu xiàng',
  相女配夫: 'xiàng nǚ pèi fū',
  相切相磋: 'xiāng qiē xiāng cuō',
  相时而动: 'xiàng shí ér dòng',
  相鼠有皮: 'xiàng shǔ yǒu pí',
  相依为命: 'xiāng yī wéi mìng',
  相与为一: 'xiāng yǔ wéi yī',
  香培玉琢: 'xiang pei yu zuo',
  响遏行云: 'xiǎng è xíng yún',
  想望风褱: 'xiǎng wàng fēng shèng',
  橡皮钉子: 'xiàng pí dìng zǐ',
  削草除根: 'xuē cǎo chú gēn',
  削尖脑袋: 'xuē jiān nǎo dài',
  削铁如泥: 'xuē tiě rú ní',
  削木为吏: 'xuē mù wéi lì',
  削职为民: 'xuē zhí wéi mín',
  削铁无声: 'xuē tiě wú shēng',
  削趾适屦: 'xuē zhǐ shì jù',
  削株掘根: 'xuē zhū jué gēn',
  削足适履: 'xuē zú shì lǚ',
  枵腹终朝: 'xiāo fù zhōng cháo',
  宵衣旰食: 'xiāo yī gàn shí',
  鸮鸣鼠暴: 'zhāng míng shǔ bào',
  硝云弹雨: 'xiāo yún dàn yǔ',
  小家子气: 'xiǎo jiā zi qì',
  小廉曲谨: 'xiǎo lián qǔ jǐn',
  小眼薄皮: 'xiǎo yǎn bó pí',
  晓行夜宿: 'xiǎo xíng yè sù',
  晓行夜住: 'xiǎo xíng yè zhù',
  校短量长: 'jiào duǎn liáng cháng',
  敩学相长: 'zuàn xué xiāng cháng',
  邪不干正: 'xié bù gān zhèng',
  邪魔外祟: 'xié mó wai suì',
  胁肩累足: 'xié jiān lěi zú',
  挟势弄权: 'jiā shì nòng quán',
  挟主行令: 'jiā zhǔ xíng lìng',
  斜行横阵: 'xié xíng héng zhèn',
  泄露天机: 'xiè lòu tiān jī',
  卸磨杀驴: 'xiè mò shā lǘ',
  心不应口: 'xīn bù yīng kǒu',
  心驰魏阙: 'xīn chí wèi què',
  心广体胖: 'xīn guǎng tǐ pán',
  心急火燎: 'xīn jí huǒ liǎo',
  心口相应: 'xīn kǒu xiāng yīng',
  心宽体胖: 'xīn kuān tǐ pán',
  心手相忘: 'xīn shǒu xiāng wàng',
  心手相应: 'xīn shǒu xiāng yìng',
  心同止水: 'xīn rú zhǐ shuǐ',
  心在魏阙: 'xīn zài wèi què',
  心瞻魏阙: 'xīn zhān wèi què',
  心拙口夯: 'xīn zhuō kǒu bèn',
  信步而行: 'xìn bù ér xíng',
  兴高采烈: 'xìng gāo cǎi liè',
  兴高彩烈: 'xìng gāo cǎi liè',
  兴观群怨: 'xìng guān qún yuàn',
  兴如嚼蜡: 'xìng rú jiáo là',
  兴文匽武: 'xīng wén diào wǔ',
  星行电征: 'xīng xíng diàn zhēng',
  星行夜归: 'xīng xíng yè guī',
  腥风血雨: 'xīng fēng xuè yǔ',
  腥闻在上: 'xíng wén zài shàng',
  行兵布阵: 'xíng bīng bù zhèn',
  行不从径: 'xíng bù cóng jìng',
  行不贰过: 'xíng bù èr guò',
  行不副言: 'xíng bù fù yán',
  行不苟合: 'xíng bù gǒu hé',
  行不履危: 'xíng bù lǚ wēi',
  行不胜衣: 'xíng bù shèng yī',
  行步如飞: 'xíng bù rú fēi',
  行不逾方: 'xíng bù yú fāng',
  行不由径: 'xíng bù yóu jìng',
  行藏用舍: 'xíng cáng yòng shě',
  行成于思: 'xíng chéng yú sī',
  行古志今: 'xíng gǔ zhì jīn',
  行号巷哭: 'xíng háo xiàng kū',
  行号卧泣: 'xíng háo wò qì',
  行合趋同: 'xíng hé qū tóng',
  行己有耻: 'xíng jǐ yǒu chǐ',
  行将就木: 'xíng jiāng jiù mù',
  行奸卖俏: 'xíng jiān mài qiào',
  行眠立盹: 'xíng mián lì dǔn',
  行若狗彘: 'xíng ruò gǒu zhì',
  行若无事: 'xíng ruò wú shì',
  行尸走骨: 'xíng shī zǒu gǔ',
  行尸走肉: 'xíng shī zǒu ròu',
  行师动众: 'xíng shī dòng zhòng',
  行思坐想: 'xíng sī zuò xiǎng',
  行思坐忆: 'xíng sī zuò yì',
  行思坐筹: 'xíng sī zuò chóu',
  行同狗豨: 'xíng tóng gǒu xī',
  行同狗彘: 'xíng tóng gǒu zhì',
  行同能偶: 'xíng tóng néng ǒu',
  行侠好义: 'xíng xiá hào yì',
  行险徼幸: 'xíng xiǎn jiǎo xìng',
  行崄侥幸: 'xíng xiǎn jiǎo xìng',
  行香挂牌: 'xíng xiāng guà pái',
  行行蛇蚓: 'háng háng shé yǐn',
  行易知难: 'xíng yì zhī nán',
  行有余力: 'xíng yǒu yú lì',
  行远升高: 'xíng yuǎn shēng gāo',
  行远自迩: 'xíng yuǎn zì ěr',
  行云流水: 'xíng yún liú shuǐ',
  行针步线: 'xíng zhēn bù xiàn',
  行之有效: 'xíng zhī yǒu xiào',
  行住坐卧: 'xíng zhù zuò wò',
  行浊言清: 'xíng zhuó yán qīng',
  兄死弟及: 'xiōng féi dì jí',
  汹涌彭湃: 'xiōng yǒng péng pai',
  汹涌淜湃: 'xiōng yǒng péng pai',
  熊据虎跱: 'xióng jù hǔ shēn',
  修鳞养爪: 'xiū lín yǎng zhǎo',
  修身洁行: 'xiū shēn jié xíng',
  羞人答答: 'xiū rén dā dā',
  绣花枕头: 'xiù huā zhěn tóu',
  褎然冠首: 'yòu rán guàn shǒu',
  虚晃一枪: 'xiù huàng yī qiāng',
  魆风骤雨: 'zhuō fēng zhòu yǔ',
  畜妻养子: 'xù qī yǎng zǐ',
  絮絮叨叨: 'xù xù dāo dāo',
  轩鹤冠猴: 'xuān hè guàn hóu',
  揎拳捋袖: 'xuān quán luō xiù',
  揎拳捰袖: 'xuān quán lǒng xiù',
  悬龟系鱼: 'xuán guī jì yú',
  悬狟素飡: 'xuán huán sù kòu',
  悬石程书: 'xuán dàn chéng shū',
  旋干转坤: 'xuán qián zhuǎn kūn',
  炫石为玉: 'xuàn shí wéi yù',
  炫巧斗妍: 'xuàn qiǎo dòu yán',
  炫玉贾石: 'xuàn yù gǔ shí',
  衒玉贾石: 'zuì yù jiǎ shí',
  穴居野处: 'xué jū yě chǔ',
  雪鸿指爪: 'xuě hóng zhǐ zhǎo',
  血风肉雨: 'xuè fēng ròu yǔ',
  血光之灾: 'xuè guāng zhī zāi',
  血红蛋白: 'xuè hóng dàn bái',
  血盆大口: 'xuè pén dà kǒu',
  血染沙场: 'xuè rǎn shā chǎng',
  血雨腥风: 'xuè yǔ xīng fēng',
  血债累累: 'xuè zhài lěi lěi',
  埙篪相和: 'xūn chí xiāng hè',
  熏莸同器: 'xún yóu tóng qì',
  寻欢作乐: 'xún huān zuò lè',
  寻行数墨: 'xún háng shǔ mò',
  寻行逐队: 'xún xíng zhú duì',
  压良为贱: 'yā liáng wéi jiàn',
  鸭步鹅行: 'yā bù é xíng',
  鸭行鹅步: 'yā xíng é bù',
  咽苦吐甘: 'yàn kǔ tǔ gān',
  咽苦吞甘: 'yàn kǔ tūn gān',
  烟视媚行: 'yān shì mèi xíng',
  烟熏火燎: 'yān xūn huǒ liǎo',
  妍蚩好恶: 'yán chī hǎo è',
  言必有中: 'yán bì yǒu zhòng',
  言不逮意: 'yán bù dǎi yì',
  言不顾行: 'yán bù gù xíng',
  言不及行: 'yán bù jí xíng',
  言从计行: 'yán cóng jì xíng',
  言颠语倒: 'yán diān yǔ dǎo',
  言多伤行: 'yán duō shāng xíng',
  言方行圆: 'yán fāng xíng yuán',
  言芳行洁: 'yán fāng xíng jié',
  言清行浊: 'yán qīng xíng zhuó',
  言听计行: 'yán tīng jì xíng',
  言听事行: 'yán tīng shì xíng',
  言听行从: 'yán tīng xíng cóng',
  言为心声: 'yán wéi xīn shēng',
  言文行远: 'yán wén xíng yuǎn',
  言信行果: 'yán xìn xíng guǒ',
  言扬行举: 'yán yáng xíng jǔ',
  岩居穴处: 'yán jū xué chǔ',
  岩栖穴处: 'yán qī xué chǔ',
  研京练都: 'yán jīng liàn dōu',
  偃革为轩: 'yǎn gé wéi xuān',
  掞藻飞声: 'shǎn zǎo fēi shēng',
  雁泊人户: 'yàn bó rén hù',
  燕巢幙上: 'yàn cháo yú shàng',
  燕处危巢: 'yàn chǔ wēi cháo',
  燕处焚巢: 'yàn chǔ fén cháo',
  燕岱之石: 'yān dài zhī shí',
  燕歌赵舞: 'yān gē zhào wǔ',
  燕驾越毂: 'yān jià yuè gū',
  燕金募秀: 'yān jīn mù xiù',
  燕骏千金: 'yān jùn qiān jīn',
  燕雀处堂: 'yàn què chǔ táng',
  燕雀处屋: 'yàn què chǔ wū',
  燕石妄珍: 'yān shí wàng zhēn',
  燕市悲歌: 'yān shì bēi gē',
  燕昭好马: 'yān zhāo hǎo mǎ',
  燕昭市骏: 'yān zhāo shì jùn',
  燕子衔食: 'yàn zǐ xián shí',
  鞅鞅不乐: 'yāng yāng bù lè',
  扬风扢雅: 'yáng fēng bào yǎ',
  扬厉铺张: 'yáng lì pù zhāng',
  扬眉眴目: 'yáng méi shùn mù',
  羊肠九曲: 'yáng cháng jiǔ qǔ',
  羊羔美酒: 'yán gāo měi jiǔ',
  洋为中用: 'yáng wéi zhōng yòng',
  洋洋纚纚: 'yáng yáng sǎ sǎ',
  卬首信眉: 'áng shǒu shēn méi',
  卬头阔步: 'áng tóu kuò bù',
  仰事俯畜: 'yǎng shì fǔ xù',
  仰屋着书: 'yǎng wū zhù shū',
  养精畜锐: 'yǎng jīng xù ruì',
  养音九皋: 'yǎng yīn jiǔ gāo',
  养尊处优: 'yǎng zūn chǔ yōu',
  幺麽小丑: 'yāo mǒ xiǎo chǒu',
  吆五喝六: 'yāo wǔ hè liù',
  瑶池女使: 'yáo shi nǚ shǐ',
  咬血为盟: 'yǎo xuè wéi méng',
  野调无腔: 'yě diào wú qiāng',
  业业矜矜: 'yè yè jīn jīn',
  叶公好龙: 'yè gōng hào lóng',
  叶落归根: 'yè luò huī gēn',
  夜静更阑: 'yè jìng gēng lán',
  一暴十寒: 'yī pù shí hán',
  一笔抹摋: 'yī bǐ mò sà',
  一笔抹煞: 'yī bǐ mǒ shā',
  一鞭先著: 'yī biān xiān zhuó',
  一倡百和: 'yī chàng bǎi hè',
  一唱一和: 'yī chàng yī hè',
  一尘不到: 'yī chén bù dào',
  一得之功: 'yī dé zhī gōng',
  一得之见: 'yī dé zhī jiàn',
  一得之愚: 'yī dé zhī yú',
  一帆风顺: 'yī fán fēng shùn',
  一个半个: 'yī gè bàn gè',
  一股劲儿: 'yī gǔ jìn er',
  一毫不差: 'yī háo bù chā',
  一哄而散: 'yī hòng ér sàn',
  一哄而起: 'yī hōng ér qǐ',
  一哄而上: 'yì hōng ér shàng',
  一呼再喏: 'yī hū zài nuò',
  一还一报: 'yī huán yī bào',
  一见了然: 'yī jiàn le rán',
  一蹶不振: 'yī jué bù zhèn',
  一了百当: 'yī liǎo bǎi dàng',
  一了百了: 'yī liǎo bǎi liǎo',
  一鳞半爪: 'yī lín bàn zhǎo',
  一鳞片爪: 'yī lín piàn zhǎo',
  一鳞一爪: 'yī lín yī zhǎo',
  一模一样: 'yī mú yī yàng',
  一目五行: 'yī mù wǔ háng',
  一年到头: 'yì nián dào tóu',
  一年一度: 'yī nián yī dù',
  一念之差: 'yī niàn zhī chā',
  一片散沙: 'yī piàn sàn shā',
  一切万物: 'yī qiē wàn wù',
  一丘之貉: 'yī qiū zhī hé',
  一邱之貉: 'yī qiū zhī hè',
  一日三省: 'yī rì sān xǐng',
  一曲阳关: 'yī qǔ yáng guān',
  一岁载赦: 'yī suì zài shè',
  一吐为快: 'yī tǔ wéi kuài',
  一无长物: 'yī wú cháng wù',
  一无所得: 'yī wú suǒ dé',
  一现昙华: 'yī xiàn tán huā',
  一笑了事: 'yī xiào le shì',
  一笑了之: 'yī xiào liǎo zhī',
  一言为定: 'yī yán wéi dìng',
  一语破的: 'yī yǔ pò dì',
  一语中的: 'yī yǔ zhōng dì',
  一之为甚: 'yī zhī wéi shèn',
  一重一掩: 'yī chóng yī yǎn',
  一走了之: 'yī zǒu liǎo zhī',
  衣被群生: 'yì bèi qún shēng',
  衣冠楚楚: 'yī guān chǔ chǔ',
  衣单食薄: 'yī dān shí bó',
  衣冠禽兽: 'yī guān qín shòu',
  衣冠土枭: 'yī guān tǔ xiāo',
  衣冠枭獍: 'yī guān xiāo jìng',
  衣锦过乡: 'yì jǐn guò xiāng',
  衣锦还乡: 'yì jǐn huán xiāng',
  衣锦食肉: 'yì jǐn shí ròu',
  衣锦夜行: 'yì jǐn yè xíng',
  衣锦昼行: 'yì jǐn zhòu xíng',
  衣裳之会: 'yī shāng zhī huì',
  衣轻乘肥: 'yì qīng chéng féi',
  衣食住行: 'yī shí zhù xíng',
  衣宵食旰: 'yī xiāo shí gàn',
  衣绣昼行: 'yì xiù zhòu xíng',
  衣租食税: 'yì zū shí shuì',
  依头缕当: 'yī tóu lǚ dàng',
  移的就箭: 'yí dì jiù jiàn',
  移山倒海: 'yí shān dǎo hǎi',
  移孝为忠: 'yí xiào wéi zhōng',
  遗寝载怀: 'yí qǐn zài huái',
  遗世忘累: 'yí shì wàng lěi',
  疑行无成: 'yí xíng wú chéng',
  乙种粒子: 'yǐ zhǒng lì zǐ',
  乙种射线: 'yǐ zhǒng shè xiàn',
  以白为黑: 'yǐ bái wéi hēi',
  以不济可: 'yǐ fǒu jì kě',
  以大恶细: 'yǐ dà wù xì',
  以耳为目: 'yǐ ěr wéi mù',
  以法为教: 'yǐ fǎ wéi jiào',
  以攻为守: 'yǐ gōng wéi shǒu',
  以宫笑角: 'yǐ gōng xiào jué',
  以古为鉴: 'yǐ gǔ wéi jiàn',
  以古为镜: 'yǐ gǔ wéi jìng',
  以规为瑱: 'yǐ guī wéi tiàn',
  以黑为白: 'yǐ hēi wéi bái',
  以毁为罚: 'yǐ huǐ wéi fá',
  以己度人: 'yǐ jǐ duó rén',
  以利累形: 'yǐ lì lěi xíng',
  以邻为壑: 'yǐ lín wéi hè',
  以鹿为马: 'yǐ lù wéi mǎ',
  以筌为鱼: 'yǐ quán wéi yú',
  以忍为阍: 'yǐ rěn wéi hūn',
  以日为年: 'yǐ rì wéi nián',
  以慎为键: 'yǐ shèn wéi jiàn',
  以身许国: 'yǐ shēng xǔ guó',
  以升量石: 'yǐ shēng liáng dàn',
  以守为攻: 'yǐ shǒu wéi gōng',
  以书为御: 'yǐ shū wéi yù',
  以水济水: 'yǐ shuǐ jǐ shuǐ',
  以疏间亲: 'yǐ shū jiàn qīn',
  以水洗血: 'yǐ shuǐ xǐ xuè',
  以退为进: 'yǐ tuì wéi jìn',
  以微知着: 'yǐ wēi zhī zhù',
  以血洗血: 'yǐ xuè xǐ xuè',
  以牙还牙: 'yǐ yá huán yá',
  以言为讳: 'yǐ yán wéi huì',
  以眼还眼: 'yǐ yǎn huán yǎn',
  以意为之: 'yǐ yì wéi zhī',
  以誉为赏: 'yǐ yù wéi shǎng',
  以紫为朱: 'yǐ zǐ wéi zhū',
  蚁斗蜗争: 'yǐ dòu wō zhēng',
  蚁集蜂攒: 'yǐ jí fēng cuán',
  蚁聚蜂攒: 'yǐ jù fēng cuán',
  蚁拥蜂攒: 'yǐ yōng fēng cuán',
  倚姣作媚: 'yǐ jiāo zuò mèi',
  倚闾望切: 'yǐ lǘ wàng qiē',
  义薄云天: 'yì bó yún tiān',
  异曲同工: 'yì qǔ tóng gōng',
  抑塞磊落: 'yì sè lěi luò',
  易地而处: 'yì dì ér chǔ',
  逸尘断鞅: 'yì chén duàn yāng',
  逸兴遄飞: 'yì xìng chuán fēi',
  逸兴横飞: 'yì xìng héng fēi',
  逸兴云飞: 'yì xìng yún fēi',
  意气相得: 'yì qì xiāng dé',
  意想不到: 'yì xiǎng bù dào',
  意兴索然: 'yì xīng suǒ rán',
  溢美溢恶: 'yì měi yì lè',
  因敌为资: 'yīn dí wéi zī',
  因公假私: 'yīn gōng jiǎ sī',
  因公行私: 'yīn gōng xíng sī',
  因祸为福: 'yīn huò wéi fú',
  因树为屋: 'yīn shù wéi wū',
  因缘为市: 'yīn yuán wéi shì',
  阴错阳差: 'yīn cuò yáng chā',
  阴差阳错: 'yīn chā yáng cuò',
  淫词艳曲: 'yín cí yàn qǔ',
  淫心匿行: 'yín xīn nì xíng',
  淫言诐行: 'yín yán bì xíng',
  淫言媟语: 'yín yán liǎng yǔ',
  龈齿弹舌: 'yín chǐ dàn shé',
  引过自责: 'yǐn guò zì zé',
  引吭悲歌: 'yǐn háng bēi gē',
  引吭高唱: 'yǐn háng gāo chàng',
  引吭高歌: 'yǐn háng gāo gē',
  引吭高声: 'yǐn háng gāo shēng',
  引绳切墨: 'yǐn shéng qiē mò',
  引新吐故: 'yǐn xīn tǔ gù',
  饮冰食蘖: 'yǐn bīng shí bò',
  饮胆尝血: 'yǐn dǎn cháng xuè',
  饮犊上流: 'yìn dú shàng liú',
  饮血茹毛: 'yǐn xuè rú máo',
  隐占身体: 'yin zhan shen qi',
  印累绶若: 'yìn léi shòu ruò',
  应弦而倒: 'yìng xián ér dǎo',
  应天顺时: 'yīng tiān shùn shí',
  莺飞草长: 'yīng fēi cǎo zhǎng',
  莺吟燕儛: 'yīng yín yàn sāi',
  鹰心雁爪: 'yīng xīn yàn zhǎo',
  盈篇累牍: 'yíng piān lěi dú',
  盈千累万: 'yíng qiān lěi wàn',
  营蝇斐锦: 'yíng yíng fēi jǐn',
  蝇攒蚁附: 'yíng cuán yǐ fù',
  郢书燕说: 'yǐng shū yān shuō',
  蝇攒蚁聚: 'yíng cuán yǐ jù',
  影子内阁: 'yǐng zi nèi gé',
  庸言庸行: 'yōng yán yōng xíng',
  庸中皦皦: 'yōng zhōng bì tóng',
  雍容大雅: 'yōng róng dà yǎ',
  饔飧不给: 'yōng sūn bù jǐ',
  勇冠三军: 'yǒng guàn sān jūn',
  用舍行藏: 'yòng shě xíng cáng',
  用行舍藏: 'yòng xíng cáng shě',
  优孟衣冠: 'yōu mèng yī guān',
  尤云殢雨: 'yóu yún zhì yǔ',
  油干灯尽: 'yóu gàn dēng jìn',
  油腔滑调: 'yóu qiāng huá diào',
  游必有方: 'yōu bì yǒu fāng',
  游手好闲: 'yóu shǒu hào xián',
  有蠙可乘: 'yǒu bīn kě chéng',
  有的放矢: 'yǒu dì fàng shǐ',
  有国难投: 'yǒu guó nán tóu',
  有机玻璃: 'yǒu jī bō li',
  有加无已: 'yǒu jiā wǔ yǐ',
  有借无还: 'yǒu jiè wú huán',
  有隙可乘: 'yǒu xì kě chèng',
  有血有肉: 'yǒu xuè yǒu ròu',
  有一得一: 'yǒu yī dé yī',
  又弱一个: 'yòu ruò yī gè',
  幼学壮行: 'yòu xué zhuàng xíng',
  于家为国: 'yú jiā wéi guó',
  于今为烈: 'yú jīn wéi liè',
  予取予夺: 'yú qǔ yú duó',
  予取予求: 'yú qǔ yú qiú',
  予取予携: 'yú qǔ yú xié',
  予智予雄: 'yú zhì yú xióng',
  余食赘行: 'yú shí zhuì xíng',
  余勇可贾: 'yú yǒng kě gǔ',
  杅穿皮蠹: 'yú chuān shuǐ dù',
  鱼封雁帖: 'yú fēng yàn tiē',
  鱼贯而行: 'yú guàn ér xíng',
  鱼贯雁行: 'yú guàn yàn xíng',
  鱼目混珎: 'yú mù hùn zhū',
  鱼尾雁行: 'yú wěi yàn xíng',
  渔夺侵牟: 'yú duó qīn móu',
  渔阳鞞鼓: 'yǔ yáng pí gǔ',
  逾墙钻隙: 'yú qiáng zuān xì',
  榆木疙瘩: 'yú mù gē da',
  与民更始: 'yǔ rén gēng shǐ',
  与民除害: 'yǔ hǔ chú hài',
  与时消息: 'yǔ shí xiāo xi',
  与世沉浮: 'yú shì chén fú',
  与世无争: 'yú shì wú zhēng',
  雨僝风僽: 'yǔ chán fēng zhòu',
  雨僝云僽: 'yǔ chán yún zhòu',
  雨僽风僝: 'yǔ zhòu fēng chán',
  禹行舜趋: 'yǔ xíng shùn qū',
  语不惊人: 'yǔ bù jīng rèn',
  语笑喧阗: 'yǔ xiào xuān tiān',
  玉卮无当: 'yù zhī wú dàng',
  吁咈都俞: 'yù fú dōu yú',
  吁天呼地: 'yù tiān hū dì',
  郁郁累累: 'yù yù lěi lěi',
  遇难成祥: 'yù nàn chéng xiáng',
  遇难呈祥: 'yù nàn chéng xiáng',
  鹬蚌相斗: 'yù bàng xiāng dòu',
  鬻鸡为凤: 'yù jī wéi fèng',
  鬻矛誉楯: 'yù máo yù dùn',
  鬻驽窃价: 'yù nǔ qiè jià',
  冤家路狭: 'yuān jia lù xiá',
  冤家对头: 'yuān jia duì tóu',
  渊涓蠖濩: 'yuān juān huò hù',
  渊清玉絜: 'yuān qīng yù jié',
  远不间亲: 'yuǎn bù jiàn qīn',
  怨声载道: 'yuàn shēng zài dào',
  约法三章: 'yuè fǎ sān zhāng',
  月露风云: 'yuè lù fēng yún',
  月落参横: 'yuè luò shēn héng',
  月没参横: 'yuè mò shēn héng',
  月晕础润: 'yuè yūn chǔ rùn',
  月中折桂: 'yuè zhōng shé guì',
  岳镇渊渟: 'yuè zhèn yuān tīng',
  云窗雾槛: 'yún chuāng wù jiàn',
  云泥之差: 'yún ní zhī chā',
  云舒霞卷: 'yún shū xiá juǎn',
  云行雨洽: 'yún xíng yǔ qià',
  云行雨施: 'yún xíng yǔ shī',
  殒身不恤: 'yǔn shēn bú xù',
  运转时来: 'yùn zhuǎn shí lái',
  晕头转向: 'yūn tóu zhuàn xiàng',
  灾难深重: 'zāi nán shēn zhòng',
  载沉载浮: 'zài chén zài fú',
  载歌且舞: 'zài gē qiě wǔ',
  载歌载舞: 'zài gē zài wǔ',
  载酒问字: 'zài jiǔ wèn zì',
  载驱载驰: 'zài qū zài chí',
  载笑载言: 'zài xiào zài yán',
  载一抱素: 'zài yī bào sù',
  载舟覆舟: 'zài zhōu fù zhōu',
  在劫难逃: 'zài jié nán táo',
  攒锋聚镝: 'cuán fēng jù dí',
  攒零合整: 'cuán líng hé zhěng',
  攒眉蹙额: 'cuán mei cù é',
  攒眉苦脸: 'zǎn méi kǔ liǎn',
  攒三聚五: 'cuán sān jù wǔ',
  攒三集五: 'cuán sān jí wǔ',
  臧谷亡羊: 'zāng gǔ wáng yáng',
  臧穀亡羊: 'zāng gǔ wáng yáng',
  脏污狼藉: 'zāng wū láng jí',
  凿龟数策: 'záo guī shǔ cè',
  凿坏而遁: 'záo pī ér dùn',
  凿坏以遁: 'záo pī yǐ dùn',
  早占勿药: 'zǎo zhān wù yào',
  造谣中伤: 'zào yáo zhòng shāng',
  择善而行: 'zé shàn ér xíng',
  责无旁贷: 'zé wú páng dài',
  责有所归: 'zé yǒu suǒ guī',
  责有攸归: 'zé yǒu yōu guī',
  曾不惨然: 'zeng bu chan ran',
  曾参杀人: 'zēng shēn shā rén',
  曾母投杼: 'zēng mǔ tóu zhù',
  沾沾自好: 'zhān zhān zì hào',
  詹言曲说: 'zhān yán qǔ shuō',
  斩钉切铁: 'zhǎn dīng qiē tiě',
  斩将搴旗: 'zhǎn jiàng qiān qí',
  斩将刈旗: 'zhǎn jiàng yì qí',
  斩头沥血: 'zhǎn tóu lì xuè',
  占风使帆: 'zhān fēng shǐ fān',
  占风望气: 'zhān fēng wàng qì',
  战天斗地: 'zhàn tiān dòu dì',
  湛恩汪濊: 'zhàn ēn wāng hún',
  张牙舞爪: 'zhāng yá wǔ zhǎo',
  章句小儒: 'zhāng jù xiāo rú',
  彰明较着: 'zhāng míng jiào zhù',
  獐麇马鹿: 'zhāng jūn mǎ lù',
  招架不住: 'zhāo jià bù zhù',
  昭德塞违: 'zhāo dé sè wéi',
  折而族之: 'zhe er zu zi',
  折箭为誓: 'shé jiàn wéi shì',
  折腰五斗: 'shé yāo wǔ dòu',
  赭衣塞路: 'zhě yī sài lù',
  这么点儿: 'zhè me diǎn er',
  贞松劲柏: 'zhēn sōng jìng bǎi',
  针头削铁: 'zhēn tóu xuē tiě',
  真相毕露: 'zhēn xiāng bì lù',
  枕干之雠: 'zhěn gàn zhī chóu',
  枕戈饮血: 'zhěn gē yǐn xuè',
  枕石嗽流: 'zhěn shí shù liú',
  枕石漱流: 'zhěn shí sòu liú',
  枕席还师: 'zhěn xí huán shī',
  振兵泽旅: 'zhèn bīng shì lǚ',
  争强斗狠: 'zhēng qiáng dòu hěn',
  争强斗胜: 'zhēng qiáng dòu shèng',
  蒸沙为饭: 'zhēng shā wéi fàn',
  整顿干坤: 'zhěng dùn gàn kūn',
  整躬率物: 'zhěng gōng shuài wù',
  整冠纳履: 'zhěng guàn nà lǚ',
  正当防卫: 'zhèng dàng fáng wèi',
  正冠李下: 'zhèng guàn lǐ xià',
  正冠纳履: 'zhèng guàn nà lǚ',
  正身率下: 'zhèng shēn shuài xià',
  正视绳行: 'zhèng shì shéng xíng',
  正中己怀: 'zhèng zhòng jǐ huái',
  正中下怀: 'zhèng zhòng xià huái',
  支分族解: 'zhī fē zú jiě',
  支吾其词: 'zhī wū qí cí',
  支支吾吾: 'zhī zhī wú wú',
  吱哩哇啦: 'zhī lī wā lā',
  枝大于本: 'zhī dà yù běn',
  枝附叶著: 'zhī fù yiè zhuó',
  枝附叶着: 'zhī fù yiè zhuó',
  枝干相持: 'zhī gàn xiāng xhí',
  枝叶相持: 'zhī yè xīng chí',
  知疼着热: 'zhī téng zháo rè',
  知疼着痒: 'zhī téng zháo yǎng',
  知行合一: 'zhī xíng hé yī',
  知易行难: 'zhī yì xíng nán',
  执法不阿: 'zhí fǎ bù ā',
  执经问难: 'zhí jīng wèn nán',
  直道而行: 'zhí dào ér xíng',
  直扑无华: 'zhí pǔ wú huá',
  直言切谏: 'zhí yán qiē jiàn',
  植发冲冠: 'zhí fà chōng guàn',
  植发穿冠: 'zhí fà chuān guàn',
  止戈为武: 'zhǐ gē wéi wǔ',
  只争旦夕: 'zhǐ zhēng dàn xī',
  只争朝夕: 'zhǐ zhēng zhāo xī',
  指腹为婚: 'zhǐ fù wéi hūn',
  指鹿为马: 'zhǐ lù wéi mǎ',
  指囷相赠: 'zhǐ què xiāng zèng',
  指山卖磨: 'zhǐ shān mài mò',
  指山说磨: 'zhǐ shān shuō mò',
  指树为姓: 'zhǐ shù wéi xìng',
  指天为誓: 'zhǐ tiān wéi shì',
  指雁为羹: 'zhǐ yàn wéi gēng',
  指皂为白: 'zhǐ zào wéi bái',
  指皁为白: 'zhǐ zào wéi bái',
  至当不易: 'zhì dàng bù yì',
  志坚行苦: 'zhì jiān xíng kǔ',
  志洁行芳: 'zhì jié xíng fāng',
  志美行厉: 'zhì měi xíng lì',
  栉比鳞差: 'zhì bǐ lín cǐ',
  致远任重: 'zhì yuǎn rèn zhàng',
  窒碍难行: 'zhì ài nán xíng',
  彘肩斗酒: 'zhì jiān dòu jiǔ',
  智圆行方: 'zhì yuán xíng fāng',
  稚齿婑媠: 'zhì chǐ wǒ tuǒ',
  擿伏发奸: 'tī fú fā jiān',
  擿伏发隐: 'tī fú fā yǐn',
  擿奸发伏: 'tī jiān fā fú',
  擿埴索途: 'zhāi zhí suǒ tú',
  擿埴索涂: 'zhāi zhí suǒ tú',
  擿植索涂: 'zhāi zhí suǒ tú',
  钟鼎人家: 'zhōng dǐng rén jia',
  众好众恶: 'zhòng hào zhòng wù',
  众毛攒裘: 'zhòng máo cuán qiú',
  众矢之的: 'zhòng shǐ zhī dì',
  众星攒月: 'zhòng xīng cuán yuè',
  众啄同音: 'zhòng zhòu tóng yīn',
  重操旧业: 'chóng cāo jiù yè',
  重床迭架: 'chóng chuáng dié jià',
  重床迭屋: 'chóng chuáng dié wū',
  重床叠架: 'chóng chuáng dié jià',
  重床叠屋: 'chóng chuáng dié wū',
  重蹈覆辙: 'chóng dǎo fù zhé',
  重睹天日: 'chóng dǔ tiān rì',
  重铬酸钾: 'chóng gè suān jiǎ',
  重关击柝: 'chóng guān jī tuò',
  重圭叠组: 'chóng guī dié zǔ',
  重规沓矩: 'chóng guī tà jǔ',
  重规迭矩: 'chóng guī dié jǔ',
  重规累矩: 'chóng guī lèi jǔ',
  重规叠矩: 'chóng guī dié jǔ',
  重规袭矩: 'chóng guī xí jǔ',
  重珪迭组: 'chóng guī dié zǔ',
  重珪叠组: 'chóng guī dié zǔ',
  重迹屏气: 'chóng jì bǐng qì',
  重见天日: 'chóng jiàn tiān rì',
  重金兼紫: 'chóng jīn jiān zǐ',
  重金袭汤: 'chóng jīn xí tāng',
  重理旧业: 'chóng lǐ jiù yè',
  重峦迭巘: 'chóng luán dié yǎn',
  重峦迭嶂: 'chóng luán dié zhàng',
  重峦叠巘: 'chóng luán dié yǎn',
  重峦叠嶂: 'chóng luán dié zhàng',
  重峦复嶂: 'chóng luán fù zhàng',
  重门击柝: 'chóng mén jī tuò',
  重明继焰: 'chóng míng jì yàn',
  重葩累藻: 'chóng pā lèi zǎo',
  重纰貤缪: 'chóng pī yí miù',
  重起炉灶: 'chóng qǐ lú zào',
  重气徇命: 'zhòng qì xùn míng',
  重三迭四: 'chóng sān dié sì',
  重三叠四: 'chóng sān dié sì',
  重山复岭: 'chóng shān fù lǐng',
  重山复水: 'chóng shān fù shuǐ',
  重山峻岭: 'chóng shān jùn lǐng',
  重手累足: 'chóng shǒu lěi zú',
  重熙累绩: 'chóng xī lěi jì',
  重熙累洽: 'chóng xī lěi qià',
  重熙累盛: 'chóng xī lěi shèng',
  重熙累叶: 'chóng xī lěi yè',
  重兴旗鼓: 'chóng xīng qí gǔ',
  重岩迭障: 'chóng yán dié zhàng',
  重岩叠嶂: 'chóng yán dié zhàng',
  重裀列鼎: 'chóng yīn liè dǐng',
  重垣迭锁: 'chóng yuán dié suǒ',
  重垣叠锁: 'chóng yuán dié suǒ',
  重振旗鼓: 'chóng zhèn qí gǔ',
  重整旗鼓: 'chóng zhěng qí gǔ',
  重纸累札: 'chóng zhǐ lèi zhá',
  重足而立: 'chóng zú ér lì',
  重足累息: 'chóng zú lèi xī',
  重足屏气: 'chóng zú bǐng qì',
  重足屏息: 'chóng zú bǐng xī',
  重足一迹: 'chóng zú yī jì',
  侜张为幻: 'zhōu zhāng wéi huàn',
  周公吐哺: 'zhōu gōng tǔ bǔ',
  周郎顾曲: 'zhōu láng gù qǔ',
  诪张为幻: 'zhōu zhāng wéi huàn',
  肘行膝步: 'zhǒu xíng xī bù',
  昼度夜思: 'zhòu duó yè sī',
  昼干夕惕: 'zhòu gàn xī tì',
  昼夜兼行: 'zhòu yè jiān xíng',
  朱轓皁盖: 'zhū fān hǎi gài',
  朱盘玉敦: 'zhū pán yù duì',
  朱槃玉敦: 'zhū pán yù duì',
  侏儒观戏: 'zhū rǔ guān xì',
  侏儒一节: 'zhū rǔ yī jié',
  珠还合浦: 'zhū huán hé pǔ',
  铢积寸累: 'zhū jī cùn lěi',
  铢两悉称: 'zhū liǎng xī chèn',
  铢量寸度: 'zhū liáng cùn duó',
  铢铢校量: 'zhū zhū xiào liàng',
  竹篮打水: 'zhú lán dá shuǐ',
  逐物不还: 'zhú wù bù huán',
  属词比事: 'zhǔ cí bǐ shì',
  属辞比事: 'zhǔ cí bǐ shì',
  属毛离里: 'zhǔ máo lí lǐ',
  属垣有耳: 'zhǔ yuán yǒu ěr',
  助桀为暴: 'zhù jié wéi bào',
  助桀为恶: 'zhù jié wéi è',
  助桀为虐: 'zhù jié wéi nüè',
  助天为虐: 'zhù tiān wéi nüè',
  助纣为虐: 'zhù zhòu wéi nüè',
  杼柚空虚: 'zhù zhóu kōng xū',
  杼柚其空: 'zhù zhóu qí kōng',
  杼柚之空: 'zhù zhóu zhī kōng',
  祝咽祝哽: 'zhù yān zhù gěng',
  筑坛拜将: 'zhù tán bài jiàng',
  铸剑为犁: 'zhù jiàn wéi lí',
  箸长碗短: 'zhù chàng wǎn duǎn',
  拽布拖麻: 'zhuāi bù tuō má',
  拽耙扶犁: 'zhuāi pá fú lí',
  拽巷啰街: 'zhuài xiàng luó jiē',
  拽巷攞街: 'zhuài xiàng luǒ jiē',
  转败为功: 'zhuǎn bài wéi gōng',
  转败为成: 'zhuǎn bài wéi chéng',
  转败为胜: 'zhuǎn bài wéi shèng',
  转悲为喜: 'zhuǎn bēi wéi xǐ',
  转嗔为喜: 'zhuǎn chēn wéi xǐ',
  转愁为喜: 'zhuǎn chóu wéi xǐ',
  转斗千里: 'zhuǎn dòu qiān lǐ',
  转祸为福: 'zhuǎn huò wéi fú',
  转来转去: 'zhuàn lái zhuàn qù',
  转弯抹角: 'zhuǎn wān mò jiǎo',
  转湾抹角: 'zhuǎn wān mò jiǎo',
  转危为安: 'zhuǎn wēi wéi ān',
  转忧为喜: 'zhuǎn yōu wéi xǐ',
  转灾为福: 'zhuǎn zāi wéi fú',
  庄严宝相: 'zhuāng yán bǎo xiàng',
  装模作样: 'zhuāng mú zuò yàng',
  壮发冲冠: 'zhuàng fā chōng guàn',
  追风摄景: 'zhuī fēng niè jǐng',
  追欢作乐: 'zhuī huān zuò lè',
  追亡逐北: 'zhuī bēn zhú běi',
  椎锋陷陈: 'chuī fēng xiàn chén',
  椎锋陷阵: 'chuí fēng xiàn zhèn',
  椎肤剥髓: 'chuí fū bō suǐ',
  椎肤剥体: 'chuí fū bō tǐ',
  椎埋狗窃: 'chuí mái gǒu qiè',
  椎埋屠狗: 'chuí mái tú gǒu',
  椎牛发冢: 'chuí niú fā zhǒng',
  椎牛歃血: 'chuí niú shà xuè',
  椎牛飨士: 'chuí niú xiǎng shì',
  椎天抢地: 'chuí tiān qiǎng dì',
  椎心顿足: 'chuí xīn dùn zú',
  椎心呕血: 'chuí xīn ǒu xuè',
  椎心泣血: 'chuí xīn qì xuè',
  椎心饮泣: 'chuí xīn yǐn qì',
  椎胸顿足: 'chuí xiōng dùn zú',
  椎胸跌足: 'chuí xiōng diē zú',
  椎膺顿足: 'chuí yīng dùn zú',
  锥处囊中: 'zhuī chǔ náng zhōng',
  灼艾分痛: 'zhuó ài fēn tòng',
  斫雕为朴: 'zhuó diāo wéi pǔ',
  斫琱为朴: 'zhuó diāo wéi pǔ',
  着人先鞭: 'zhuó rén xiān biān',
  着手成春: 'zhuó shǒu chéng chūn',
  着书立说: 'zhù shū lì shuō',
  擢发莫数: 'zhuó fà mò shǔ',
  擢发难数: 'zhuó fà nán shǔ',
  资深望重: 'zī shēng wàng zhòng',
  子为父隐: 'zǐ wéi fù yǐn',
  自吹自擂: 'zì chuī zì léi',
  自我吹嘘: 'zì wǒ chuí xū',
  自相惊忧: 'zì xiāng jīng rǎo',
  恣行无忌: 'zì xíng wú jì',
  恣意妄行: 'zì yì wàng xíng',
  纵曲枉直: 'zòng qǔ wǎng zhí',
  走花溜水: 'zǒu huā liū bīng',
  走为上策: 'zǒu wéi shàng cè',
  走为上着: 'zǒu wèi shàng zhaō',
  钻冰求酥: 'zuān bīng qiú sū',
  钻冰求火: 'zuān bīng qiú huǒ',
  钻洞觅缝: 'zuàn dòng mì féng',
  钻火得冰: 'zuān huǒ dé bīng',
  钻懒帮闲: 'zuān lǎn bāng xián',
  钻皮出羽: 'zuān pí chū yǔ',
  钻牛角尖: 'zuān niú jiǎo jiān',
  钻天打洞: 'zuān tiān dǎ dòng',
  钻天觅缝: 'zuàn tiān mì féng',
  钻头觅缝: 'zuān tóu mì fèng',
  钻隙逾墙: 'zuān xì yú qiáng',
  钻穴逾隙: 'zuān xué yú xì',
  钻穴逾墙: 'zuān xué yú qiáng',
  钻心刺骨: 'zuàn xīn cì gǔ',
  罪应万死: 'zuì yīng wàn sǐ',
  罪有应得: 'zuì yǒu yīng dé',
  罪责难逃: 'zuì zé nán táo',
  醉山颓倒: 'zuì shān tuí dǎo',
  醉吐相茵: 'zuì tǔ xiāng yīn',
  左膀右臂: 'zuǒ bǎng yòu bì',
  左宜右有: 'zuǒ yí yòu fú',
  左枝右梧: 'zuǒ zhī yòu wū',
  左支右吾: 'zuǒ zhī yòu wū',
  作歹为非: 'zuò dǎi wéi fēi',
  作嫁衣裳: 'zuò jià yī shāng',
  作困兽斗: 'zuò kùn shòu dòu',
  作舍道旁: 'zuò shě dào páng',
  坐不窥堂: 'zùo bù kuī táng',
  坐不重席: 'zuò bù chóng xí',
  坐地自划: 'zuò dì zì huá',
  坐视不救: 'zuò shī bù jiù',
};
export default DICT4;
